<template>
  <div class="card card-custom card-transparent">
    <div class="card-body p-0">
      
      <!--begin: Wizard-->
      <div
        class="wizard wizard-4"
        id="kt_wizard_v4"
        data-wizard-state="step-first"
        data-wizard-clickable="true"
      >
        <!--begin: Wizard Nav-->
        <div class="wizard-nav">
          <div class="wizard-steps">
            <div
              class="wizard-step"
              data-wizard-type="step"
              data-wizard-state="current"
            >
              <div class="wizard-wrapper">
                <div class="wizard-number">1</div>
                <div class="wizard-label">
                  <div class="wizard-title">Penerapan Perizinan Berusaha</div>
                  <div class="wizard-desc">Penerapan Perizinan Berusaha</div>
                </div>
              </div>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-number">2</div>
                <div class="wizard-label">
                  <div class="wizard-title">
                    Penyederhanaan Persyaratan Dasar Perizinan Berusaha
                  </div>
                  <div class="wizard-desc">
                    Penyederhanaan Persyaratan Dasar Perizinan Berusaha
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-step" data-wizard-type="step">
              <div class="wizard-wrapper">
                <div class="wizard-number">3</div>
                <div class="wizard-label">
                  <div class="wizard-title">Peningkatan Iklim Investasi</div>
                  <div class="wizard-desc">Peningkatan Iklim Investasi</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav -->

        <!--begin: Wizard Body-->
        <div class="card card-custom card-shadowless rounded-top-0">
          <div class="card-body p-0">
            <div class="row justify-content-center py-12 px-0 py-lg-15 px-lg-0">
              <div class="col-xl-12 col-xxl-11">
                <!--begin: Wizard Form-->
                <form class="form mt-0 mt-lg-10" id="kt_form">
                  <!--begin: Wizard Step 1-->
                  <div
                    class="pb-5"
                    data-wizard-type="step-content"
                    data-wizard-state="current"
                  >
                    <div v-if="pm.catatan_1_surveyor != null">
                      <b-alert show variant="danger"
                        >Terdapat catatan, silahkan lihat catatan
                        dibawah!</b-alert
                      >
                    </div>
                    <div
                      style="background-color: #1bc5bd"
                      class="card card-custom"
                    >
                      <div class="card-body text-green">
                        <h3 class="card-label" style="color: white">
                          <i
                            class="fa fa-info-circle"
                            style="color: white"
                            aria-hidden="true"
                          ></i>
                          Penting!
                        </h3>
                        <hr />
                        <p style="color: white">
                          Input data yang berkaitan dengan Penerapan Perizinan
                          Berusaha berdasarkan fakta yang ada dengan memilih
                          data yang sesuai. Dokumen lampiran yang diunggah
                          adalah
                          <strong style="color: yellow">halaman depan</strong>
                          dan
                          <strong style="color: yellow"
                            >halaman pengesahan</strong
                          >
                          dokumen SOP, peraturan, dan lainnya. Ukuran file
                          setiap dokumen maksimal
                          <strong style="color: yellow">500KB</strong> dengan
                          format file
                          <strong style="color: yellow">*.pdf</strong>.
                        </p>
                      </div>
                    </div>
                    <br />
                    <div class="table-responsive-sm">
                      <table class="table">
                        <thead>
                          <tr class="table-active">
                            <th style="display: none">No</th>
                            <th style="display: none">Indikator</th>
                            <!-- <th style="display:none;">Status</th> -->
                            <th style="display: none">Jawaban</th>
                            <th style="display: none">Download</th>
                            <th style="display: none">Hasil</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colspan="5" style="background-color: #ebedf3">
                              <b
                                >Penyusunan dan atau revisi peraturan daerah
                                atau peraturan kepala daerah</b
                              >
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="2">1</td>
                            <td rowspan="2">
                              Apakah ada Perda atau Perkada dalam dokumen
                              Prolegda ?
                            </td>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  Penyusunan Perda dan Perkada berdasarkan Pasal
                                  4 ayat (1), Pasal 5 ayat (1), dan Pasal 39
                                  ayat (1) PP No. 6 Tahun 2021 tentang
                                  Penyelenggaraan Perizinan Berusaha di Daerah,
                                  Pemda wajib menyesuaikan Perda dan Perkada
                                  paling lama 2 (dua) bulan terhitung sejak PP
                                  No. 6 Tahun 2021 diundangkan. Penilaian
                                  keberadaan Perkada dalam program pembentukan
                                  peraturan kepala daerah (Propemperkada)
                                  dilakukan dengan ketentuan Perkada tentang
                                  penyelenggaraan perizinan berusaha berbasis
                                  risiko terdapat dalam Propemperkada
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a1_file1)"
                                v-if="vf.p1a1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a1_file1_status == 'Sesuai'"
                                v-model="vf.p1a1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a1_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada” apabila ketentuan di atas
                                    terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila ketentuan di
                                    atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">2</td>
                            <td rowspan="7">
                              Apakah ada Konsultasi pengusulan Perda dan Perkada
                              dengan OPD daerah?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penyusunan Perda dan Perkada berdasarkan Pasal 4
                              ayat (1), Pasal 5 ayat (1), dan Pasal 39 ayat (1)
                              PP No. 6 Tahun 2021 tentang Penyelenggaraan
                              Perizinan Berusaha di Daerah, Pemda wajib
                              menyesuaikan Perda dan Perkada paling lama 2 (dua)
                              bulan terhitung sejak PP No. 6 Tahun 2021
                              diundangkan. Penilaian konsultasi pengusulan
                              Perkada dengan Organisasi Perangkat Daerah (OPD)
                              teknis dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a2_file1)"
                                v-if="vf.p1a2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a2_file1_status == 'Sesuai'"
                                v-model="vf.p1a2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a2_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a2_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a2_file2)"
                                v-if="vf.p1a2_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a2_file2_status == 'Sesuai'"
                                v-model="vf.p1a2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a2_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a2_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a2_file3)"
                                v-if="vf.p1a2_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a2_file3_status == 'Sesuai'"
                                v-model="vf.p1a2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a2_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a2_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a2_file4)"
                                v-if="vf.p1a2_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a2_file4_status == 'Sesuai'"
                                v-model="vf.p1a2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a2_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a2_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a2_file5)"
                                v-if="vf.p1a2_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a2_file5_status == 'Sesuai'"
                                v-model="vf.p1a2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a2_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">3</td>
                            <td rowspan="7">
                              Apakah ada Konsultasi pengusulan Perda dan Perkada
                              dengan Kementerian Dalam Negeri, Kementerian
                              Investasi dan Kementerian Teknis lainnya?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Kementerian Investasi/BKPM dan Kementerian Teknis
                              lainnya dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a3_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a3_file1)"
                                v-if="vf.p1a3_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a3_file1_status == 'Sesuai'"
                                v-model="vf.p1a3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a3_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a3_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a3_file2)"
                                v-if="vf.p1a3_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a3_file2_status == 'Sesuai'"
                                v-model="vf.p1a3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a3_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a3_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a3_file3)"
                                v-if="vf.p1a3_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a3_file3_status == 'Sesuai'"
                                v-model="vf.p1a3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a3_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a3_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a3_file4)"
                                v-if="vf.p1a3_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a3_file4_status == 'Sesuai'"
                                v-model="vf.p1a3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a3_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a3_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a3_file5)"
                                v-if="vf.p1a3_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a3_file5_status == 'Sesuai'"
                                v-model="vf.p1a3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a3_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">4</td>
                            <td rowspan="7">
                              Apakah ada Koordinasi pengusulan Perda dan Perkada
                              dengan Kementerian Dalam Negeri, Kementerian
                              Investasi dan Kementerian Teknis lainnya?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penyusunan Perda dan Perkada berdasarkan Pasal 4
                              ayat (1), Pasal 5 ayat (1), dan Pasal 39 ayat (1)
                              PP No. 6 Tahun 2021 tentang Penyelenggaraan
                              Perizinan Berusaha di Daerah, Pemda wajib
                              menyesuaikan Perda dan Perkada paling lama 2 (dua)
                              bulan terhitung sejak PP No. 6 Tahun 2021
                              diundangkan. Penilaian koordinasi pengusulan
                              Perkada dengan Kementerian Dalam Negeri,
                              Kementerian Investasi/BKPM dan Kementerian Teknis
                              lainnya dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a4_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Koordinasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a4_file1)"
                                v-if="vf.p1a4_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a4_file1_status == 'Sesuai'"
                                v-model="vf.p1a4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a4_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a4_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a4_file2)"
                                v-if="vf.p1a4_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a4_file2_status == 'Sesuai'"
                                v-model="vf.p1a4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a4_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a4_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digita
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a4_file3)"
                                v-if="vf.p1a4_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a4_file3_status == 'Sesuai'"
                                v-model="vf.p1a4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a4_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a4_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a4_file4)"
                                v-if="vf.p1a4_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a4_file4_status == 'Sesuai'"
                                v-model="vf.p1a4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a4_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a4_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a4_file5)"
                                v-if="vf.p1a4_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a4_file5_status == 'Sesuai'"
                                v-model="vf.p1a4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a4_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="2">5</td>
                            <td rowspan="2">
                              Apakah ada dokumen Peraturan daerah atau Peraturan
                              Kepala Daerah terkait penerapan perizinan berusaha
                              berbasis risiko?
                            </td>
                            <td>
                              <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio
                                  disabled
                                  v-model="vf.p1a5_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="some-radios"
                                  value="25"
                                  >Ada, sudah disahkan</b-form-radio
                                >
                                <b-form-radio
                                  disabled
                                  v-model="vf.p1a5_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="some-radios"
                                  value="10"
                                  >Ada, belum disahkan</b-form-radio
                                >
                                <b-form-radio
                                  disabled
                                  v-model="vf.p1a5_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="some-radios"
                                  value="0"
                                  >Belum ada</b-form-radio
                                >
                              </b-form-group>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a5_file1)"
                                v-if="vf.p1a5_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a5_nilai_status == 'Sesuai'"
                                v-model="vf.p1a5_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a5_nilai_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a5_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a5_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, sudah disahkan” apabila
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, belum disahkan” apabila
                                    ketentuan di atas tidak terpenuhi namun
                                    sudah tersedia dalam bentuk naskah/dokumen
                                    usulan. <br />
                                    3. Nilai “Belum ada” apabila ketentuan di
                                    atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">6</td>
                            <td rowspan="7">
                              Apakah ada kegiatan Sosialisasi Perda atau Perkada
                              terkait penerapam perizinan berusaha berbasis
                              risiko?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penyusunan Perda dan Perkada berdasarkan Pasal 4
                              ayat (1), Pasal 5 ayat (1), dan Pasal 39 ayat (1)
                              PP No. 6 Tahun 2021 tentang Penyelenggaraan
                              Perizinan Berusaha di Daerah, Pemda wajib
                              menyesuaikan Perda dan Perkada paling lama 2 (dua)
                              bulan terhitung sejak PP No. 6 Tahun 2021
                              diundangkan. Penilaian ada tidaknya sosialisasi
                              Perkada terkait penerapan perizinan berusaha
                              berbasis risiko dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a6_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Sosialisasi dilakukan sekurang-kurangnya 1
                                  kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a6_file1)"
                                v-if="vf.p1a6_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a6_file1_status == 'Sesuai'"
                                v-model="vf.p1a6_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a6_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a6_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a6_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a6_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a6_file2)"
                                v-if="vf.p1a6_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a6_file2_status == 'Sesuai'"
                                v-model="vf.p1a6_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a6_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a6_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a6_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a6_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a6_file3)"
                                v-if="vf.p1a6_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a6_file3_status == 'Sesuai'"
                                v-model="vf.p1a6_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a6_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a6_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a6_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a6_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat notula sosialisasi
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a6_file4)"
                                v-if="vf.p1a6_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a6_file4_status == 'Sesuai'"
                                v-model="vf.p1a6_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a6_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a6_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a6_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1a6_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1a6_file5)"
                                v-if="vf.p1a6_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1a6_file5_status == 'Sesuai'"
                                v-model="vf.p1a6_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1a6_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1a6_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1a6_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, hanya 1 kali” apabila salah
                                    satu dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="5" style="background-color: #ebedf3">
                              <b>Verifikasi</b>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="3">1</td>
                            <td rowspan="3">
                              Berapa persen verifikasi teknis dan notifikasi
                              pemenuhan standar dan persyaratan Perizinan
                              Berusaha Berbasis Risiko?
                            </td>
                            <td rowspan="2">
                              <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio
                                  disabled
                                  v-model="vf.p1b1_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="vf.p1b1_nilai"
                                  value="25"
                                  >85 – 100%</b-form-radio
                                >
                                <b-form-radio
                                  disabled
                                  v-model="vf.p1b1_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="vf.p1b1_nilai"
                                  value="15"
                                  >70 – 84,99%</b-form-radio
                                >
                                <b-form-radio
                                  disabled
                                  v-model="vf.p1b1_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="vf.p1b1_nilai"
                                  value="10"
                                  >50 - 69,99%</b-form-radio
                                >
                                <b-form-radio
                                  disabled
                                  v-model="vf.p1b1_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="vf.p1b1_nilai"
                                  value="0"
                                  >Di bawah 50%</b-form-radio
                                >
                              </b-form-group>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1b1_file1)"
                                v-if="vf.p1b1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1b1_nilai_status == 'Sesuai'"
                                v-model="vf.p1b1_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1b1_nilai_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1b1_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1b1_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr colspan="2">
                            <td>
                              <button
                                @click="unduhFile(vf.p1b1_file2)"
                                v-if="vf.p1b1_file2 != null"
                                v-b-tooltip.hover
                                title="Unduh"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Penilaian verifikasi teknis dan notifikasi
                                    pemenuhan standar dan persyaratan Perizinan
                                    Berusaha Berbasis Risiko dilakukan dengan
                                    ketentuan: <br />
                                    1. Verifikasi teknis dan notifikasi
                                    pemenuhan standar oleh pemerintah daerah
                                    terhadap permohonan perizinan berusaha
                                    dengan tingkat risiko Menengah Tinggi (MT)
                                    yang menjadi kewenangannya.<br />
                                    2. Verifikasi teknis dan notifikasi
                                    pemenuhan persyaratan oleh pemerintah daerah
                                    terhadap permohonan perizinan berusaha
                                    dengan tingkat risiko Tinggi (T) yang
                                    menjadi kewenangannya. <br />
                                    3. Penilaian verifikasi teknis dan
                                    notifikasi pemenuhan standar dan persyaratan
                                    Perizinan Berusaha Berbasis Risiko dilakukan
                                    dengan menghitung perbandingan jumlah
                                    permohonan perizinan berusaha dengan tingkat
                                    risiko MT dan T yang telah diverifikasi
                                    dengan total permohonan perizinan berusaha
                                    yang masuk ke dalam dashboard OSS Pemda
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="5" style="background-color: #ebedf3">
                              <b>Monitoring dan Evaluasi</b>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">1</td>
                            <td rowspan="7">
                              Apakah ada monitoring dan evaluasi implementasi
                              penyusunan Perda/Perkada?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penyusunan Perda dan Perkada berdasarkan Pasal 4
                              ayat (1), Pasal 5 ayat (1), dan Pasal 39 ayat (1)
                              PP No. 6 Tahun 2021 tentang Penyelenggaraan
                              Perizinan Berusaha di Daerah, Pemda wajib
                              menyesuaikan Perda dan Perkada paling lama 2 (dua)
                              bulan terhitung sejak PP No. 6 Tahun 2021
                              diundangkan. Penilaian ada tidaknya monitoring dan
                              evaluasi implementasi penyusunan perkada dilakukan
                              dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1c1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  Kegiatan monitoring dan evaluasi dilakukan
                                  sekurang-kurangnya 1 kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1c1_file1)"
                                v-if="vf.p1c1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1c1_file1_status == 'Sesuai'"
                                v-model="vf.p1c1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1c1_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1c1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1c1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1c1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1c1_file2)"
                                v-if="vf.p1c1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1c1_file2_status == 'Sesuai'"
                                v-model="vf.p1c1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1c1_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1c1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1c1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1c1_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1c1_file3)"
                                v-if="vf.p1c1_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1c1_file3_status == 'Sesuai'"
                                v-model="vf.p1c1_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1c1_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1c1_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1c1_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1c1_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  Terdapat notula kegiatan monitoring dan
                                  evaluasi
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1c1_file4)"
                                v-if="vf.p1c1_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1c1_file4_status == 'Sesuai'"
                                v-model="vf.p1c1_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1c1_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1c1_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1c1_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1c1_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1c1_file5)"
                                v-if="vf.p1c1_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1c1_file5_status == 'Sesuai'"
                                v-model="vf.p1c1_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1c1_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1c1_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1c1_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="2">2</td>
                            <td rowspan="2">
                              Apakah ada laporan kinerja implementasi OSS ?
                            </td>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p1c2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  Penilaian ada tidaknya laporan kinerja
                                  implementasi OSS dilakukan dengan ketentuan
                                  apabila laporan kinerja implementasi OSS
                                  dibuat secara formal dalam bentuk dokumen
                                  laporan lengkap fisik atau digital, bukan
                                  bahan presentasi dan sejenisnya
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p1c2_file1)"
                                v-if="vf.p1c2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p1c2_file1_status == 'Sesuai'"
                                v-model="vf.p1c2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p1c2_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p1c2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p1c2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada” apabila ketentuan di atas
                                    terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila ketentuan di
                                    atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div v-if="pm.catatan_1_surveyor != null">
                        <div class="card text-white bg-primary mb-3">
                          <!-- <div class="card-header">Header</div> -->
                          <div class="card-body">
                            <h5 class="card-title">
                              <i
                                class="fa fa-info-circle"
                                style="color: white"
                                aria-hidden="true"
                              ></i>
                              Catatan
                            </h5>
                            <hr />
                            <div
                              class="card-text"
                              v-html="pm.catatan_1_surveyor"
                            ></div>
                            <!-- <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> -->
                          </div>
                        </div>
                      </div>
                      <br />
                      <div v-if="pm.catatan_1_bkpm != null">
                        <div
                          class="card text-white bg-danger mb-3"
                          v-if="
                            (user.id_role === 'dpb' || user.id_role === 'kspb') ||
                            user.id_role === 'super_user'
                          "
                        >
                          <!-- <div class="card-header">Header</div> -->
                          <div class="card-body">
                            <h5 class="card-title">
                              <i
                                class="fa fa-info-circle"
                                style="color: white"
                                aria-hidden="true"
                              ></i>
                              Catatan dari BKPM
                            </h5>
                            <hr />
                            <div
                              class="card-text"
                              v-html="pm.catatan_1_bkpm"
                            ></div>
                            <!-- <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> -->
                          </div>
                        </div>
                      </div>
                      <br />
                      <div
                        v-if="
                          (user.id_role === 'dpb' || user.id_role === 'kspb') ||
                          user.id_role === 'super_user'
                        "
                        class="form-group row"
                      >
                        <label class="col-lg-12 col-form-label"
                          ><b>Catatan untuk surveyor</b></label
                        >
                      </div>
                      <div
                        v-if="
                          (user.id_role === 'dpb' || user.id_role === 'kspb') ||
                          user.id_role === 'super_user'
                        "
                        class="form-group row"
                      >
                        <div class="col-lg-12">
                          <vue-editor v-model="pm.catatan_1_bkpm" />
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-6"></div>
                        <div class="col-6">
                          <button
                            type="button"
                            v-if="
                              (user.id_role === 'dpb' || user.id_role === 'kspb') ||
                              user.id_role === 'super_user'
                            "
                            style="float: right"
                            @click="dokumenpenerapanperizinan"
                            class="btn btn-success font-weight-bolder text-uppercase px-9 py-4"
                          >
                            <i class="fas fa-save"></i>Kirim
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--end: Wizard Step 1-->

                  <!--begin: Wizard Step 2-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <div v-if="pm.catatan_2_surveyor != null">
                      <b-alert show variant="danger"
                        >Terdapat catatan, silahkan lihat catatan
                        dibawah!</b-alert
                      >
                    </div>
                    <div
                      style="background-color: #1bc5bd"
                      class="card card-custom"
                    >
                      <div class="card-body text-green">
                        <h3 class="card-label" style="color: white">
                          <i
                            class="fa fa-info-circle"
                            style="color: white"
                            aria-hidden="true"
                          ></i>
                          Penting!
                        </h3>
                        <hr />
                        <p style="color: white">
                          Input data yang berkaitan dengan Penyederhanaan
                          Persyaratan Dasar Perizinan Berusaha berdasarkan fakta
                          yang ada dengan memilih data yang sesuai. Dokumen
                          lampiran yang diunggah adalah
                          <strong style="color: yellow">halaman depan</strong>
                          dan
                          <strong style="color: yellow"
                            >halaman pengesahan</strong
                          >
                          dokumen SOP, peraturan, dan lainnya. Ukuran file
                          setiap dokumen maksimal
                          <strong style="color: yellow">500KB</strong> dengan
                          format file
                          <strong style="color: yellow">*.pdf</strong>.
                        </p>
                      </div>
                    </div>
                    <br />
                    <div class="table-responsive-sm">
                      <table class="table">
                        <thead>
                          <tr class="table-active">
                            <th style="display: none">No</th>
                            <th style="display: none">Indikator</th>
                            <!-- <th style="display:none;">Status</th> -->
                            <th style="display: none">Jawaban</th>
                            <th style="display: none">Download</th>
                            <th style="display: none">Hasil</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colspan="5" style="background-color: #ebedf3">
                              <b
                                >Peraturan daerah atau peraturan kepala daerah
                                terkait penyusunan Rencana Detil Tata Ruang
                                Digital</b
                              >
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="4">1</td>
                            <td rowspan="4">
                              Apakah ada Perda atau Perkada dalam dokumen
                              Prolegda?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penilaian Keberadaan Perda dalam dokumen program
                              pembentukan peraturan daerah (Propemperda) dan
                              Perkada dalam program pembentukan peraturan kepala
                              daerah (Propemperkada) dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Perda mengenai Rencana Tata Ruang Wilayah
                                  (RTRW)
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a1_file1)"
                                v-if="vf.p2a1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a1_file1_status == 'Sesuai'"
                                v-model="vf.p2a1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a1_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Perkada mengenai Rencana Detail Tata Ruang
                                  (RDTR
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a1_file2)"
                                v-if="vf.p2a1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a1_file2_status == 'Sesuai'"
                                v-model="vf.p2a1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a1_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div class="row" style="color: white">
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 32 ayat (2), dan Pasal 39 ayat (1)
                                      PP No. 6 Tahun 2021 tentang
                                      Penyelenggaraan Perizinan Berusaha di
                                      Daerah, Pemda wajib menyesuaikan Perda dan
                                      Perkada paling lama 2 (dua) bulan
                                      terhitung sejak PP No. 6 Tahun 2021
                                      diundangkan. Perda dan Perkada dimaksud
                                      adalah:
                                    </div>
                                    <div class="col-12">
                                      a. Perda mengenai Rencana Tata Ruang
                                      Wilayah (RTRW)
                                    </div>
                                    <div class="col-12">
                                      b. Perkada mengenai Rencana Detail Tata
                                      Ruang (RDTR)
                                    </div>
                                  </div>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Untuk pemerintah provinsi, nilai “Ada”
                                    apabila dapat menunjukkan naskah/dokumen
                                    usulan Perda mengenai Rencana Tata Ruang
                                    Wilayah (RTRW) dalam dokumen Propemperda.<br />
                                    2. Untuk pemerintah kabupaten/kota, nilai
                                    “Ada” apabila dapat menunjukkan
                                    naskah/dokumen usulan Perkada mengenai
                                    Rencana Detail Tata Ruang (RDTR) dalam
                                    dokumen Propemperkada. <br />
                                    3. Nilai “Tidak ada” apabila pemerintah
                                    provinsi tidak dapat memenuhi ketentuan
                                    nomor 1 dan pemerintah kabupaten/kota tidak
                                    dapat memenuhi ketentuan nomor 1 dan 2.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">2</td>
                            <td rowspan="7">
                              Apakah ada Konsultasi pengusulan Perda dan Perkada
                              dengan OPD daerah?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penilaian konsultasi pengusulan Perda dan Perkada
                              dengan Organisasi Perangkat Daerah (OPD) dilakukan
                              dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a2_file1)"
                                v-if="vf.p2a2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a2_file1_status == 'Sesuai'"
                                v-model="vf.p2a2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a2_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a2_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a2_file2)"
                                v-if="vf.p2a2_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a2_file2_status == 'Sesuai'"
                                v-model="vf.p2a2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a2_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a2_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a2_file3)"
                                v-if="vf.p2a2_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a2_file3_status == 'Sesuai'"
                                v-model="vf.p2a2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a2_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a2_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a2_file4)"
                                v-if="vf.p2a2_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a2_file4_status == 'Sesuai'"
                                v-model="vf.p2a2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a2_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a2_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a2_file5)"
                                v-if="vf.p2a2_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a2_file5_status == 'Sesuai'"
                                v-model="vf.p2a2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a2_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div class="row" style="color: white">
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 32 ayat (2), dan Pasal 39 ayat (1)
                                      PP No. 6 Tahun 2021 tentang
                                      Penyelenggaraan Perizinan Berusaha di
                                      Daerah, Pemda wajib menyesuaikan Perda dan
                                      Perkada paling lama 2 (dua) bulan
                                      terhitung sejak PP No. 6 Tahun 2021
                                      diundangkan. Perda dan Perkada dimaksud
                                      adalah:
                                    </div>
                                    <div class="col-12">
                                      a. Perda mengenai Rencana Tata Ruang
                                      Wilayah (RTRW)
                                    </div>
                                    <div class="col-12">
                                      b. Perkada mengenai Rencana Detail Tata
                                      Ruang (RDTR)
                                    </div>
                                  </div>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">3</td>
                            <td rowspan="7">
                              Apakah ada Konsultasi pengusulan Perda dan Perkada
                              dengan Kementerian Dalam Negeri, Kementerian
                              Investasi, dan Kementerian Teknis lainnya?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penilaian konsultasi pengusulan Perda dan Perkada
                              dengan Kementerian Dalam Negeri, Kementerian
                              Investasi/BKPM dan Kementerian Teknis lainnya yang
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a3_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Koordinasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a3_file1)"
                                v-if="vf.p2a3_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a3_file1_status == 'Sesuai'"
                                v-model="vf.p2a3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a3_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a3_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a3_file2)"
                                v-if="vf.p2a3_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a3_file2_status == 'Sesuai'"
                                v-model="vf.p2a3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a3_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a3_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a3_file3)"
                                v-if="vf.p2a3_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a3_file3_status == 'Sesuai'"
                                v-model="vf.p2a3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a3_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a3_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a3_file4)"
                                v-if="vf.p2a3_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a3_file4_status == 'Sesuai'"
                                v-model="vf.p2a3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a3_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a3_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a3_file5)"
                                v-if="vf.p2a3_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a3_file5_status == 'Sesuai'"
                                v-model="vf.p2a3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a3_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div class="row" style="color: white">
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 32 ayat (2), dan Pasal 39 ayat (1)
                                      PP No. 6 Tahun 2021 tentang
                                      Penyelenggaraan Perizinan Berusaha di
                                      Daerah, Pemda wajib menyesuaikan Perda dan
                                      Perkada paling lama 2 (dua) bulan
                                      terhitung sejak PP No. 6 Tahun 2021
                                      diundangkan. Perda dan Perkada dimaksud
                                      adalah
                                    </div>
                                    <div class="col-12">
                                      a. Perda mengenai Rencana Tata Ruang
                                      Wilayah (RTRW)
                                    </div>
                                    <div class="col-12">
                                      b. Perkada mengenai Rencana Detail Tata
                                      Ruang (RDTR)
                                    </div>
                                  </div>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">4</td>
                            <td rowspan="7">
                              Apakah ada koordinasi pengusulan Perda dan Perkada
                              dengan Kementerian Dalam Negeri, Kementerian
                              Investasi, dan Kementerian Teknis lainnya?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penilaian koordinasi pengusulan Perda dan Perkada
                              dengan Kementerian Dalam Negeri, Kementerian
                              Investasi/BKPM dan Kementerian Teknis lainnya
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a4_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Koordinasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a4_file1)"
                                v-if="vf.p2a4_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a4_file1_status == 'Sesuai'"
                                v-model="vf.p2a4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a4_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a4_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a4_file2)"
                                v-if="vf.p2a4_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a4_file2_status == 'Sesuai'"
                                v-model="vf.p2a4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a4_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a4_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a4_file3)"
                                v-if="vf.p2a4_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a4_file3_status == 'Sesuai'"
                                v-model="vf.p2a4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a4_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a4_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a4_file4)"
                                v-if="vf.p2a4_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a4_file4_status == 'Sesuai'"
                                v-model="vf.p2a4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a4_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a4_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a4_file5)"
                                v-if="vf.p2a4_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a4_file5_status == 'Sesuai'"
                                v-model="vf.p2a4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a4_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div class="row" style="color: white">
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 32 ayat (2), dan Pasal 39 ayat (1)
                                      PP No. 6 Tahun 2021 tentang
                                      Penyelenggaraan Perizinan Berusaha di
                                      Daerah, Pemda wajib menyesuaikan Perda dan
                                      Perkada paling lama 2 (dua) bulan
                                      terhitung sejak PP No. 6 Tahun 2021
                                      diundangkan. Perda dan Perkada dimaksud
                                      adalah
                                    </div>
                                    <div class="col-12">
                                      a. Perda mengenai Rencana Tata Ruang
                                      Wilayah (RTRW)
                                    </div>
                                    <div class="col-12">
                                      b. Perkada mengenai Rencana Detail Tata
                                      Ruang (RDTR)
                                    </div>
                                  </div>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="3">5</td>
                            <td rowspan="3">
                              Apakah ada dokumen Peraturan Daerah atau Peraturan
                              Kepala Daerah terkait penyusunan RDTR Digital?
                            </td>
                            <td rowspan="2">
                              <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio
                                  disabled
                                  v-model="vf.p2a5_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2a5_nilai"
                                  value="25"
                                  >Ada, sudah disahkan</b-form-radio
                                >
                                <b-form-radio
                                  disabled
                                  v-model="vf.p2a5_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2a5_nilai"
                                  value="10"
                                  >Ada, belum disahkan</b-form-radio
                                >
                                <b-form-radio
                                  disabled
                                  v-model="vf.p2a5_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2a5_nilai"
                                  value="0"
                                  >Belum ada</b-form-radio
                                >
                              </b-form-group>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a5_file1)"
                                v-if="vf.p2a5_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a5_nilai_status == 'Sesuai'"
                                v-model="vf.p2a5_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a5_nilai_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a5_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a5_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr colspan="2">
                            <td>
                              <button
                                @click="unduhFile(vf.p2a5_file2)"
                                v-if="vf.p2a5_file2 != null"
                                v-b-tooltip.hover
                                title="Unduh"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div class="row" style="color: white">
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 32 ayat (2), dan Pasal 39 ayat (1)
                                      PP No. 6 Tahun 2021 tentang
                                      Penyelenggaraan Perizinan Berusaha di
                                      Daerah, Pemda wajib menyesuaikan Perda dan
                                      Perkada paling lama 2 (dua) bulan
                                      terhitung sejak PP No. 6 Tahun 2021
                                      diundangkan. Perda dan Perkada dimaksud
                                      adalah
                                    </div>
                                    <div class="col-12">
                                      a. Perda mengenai Rencana Tata Ruang
                                      Wilayah (RTRW)
                                    </div>
                                    <div class="col-12">
                                      b. Perkada mengenai Rencana Detail Tata
                                      Ruang (RDTR)
                                    </div>
                                  </div>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, sudah disahkan” apabila salah
                                    satu ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, belum disahkan” apabila
                                    seluruh ketentuan di atas tidak terpenuhi
                                    namun sudah tersedia dalam bentuk
                                    naskah/dokumen usulan. <br />
                                    3. Nilai “Belum ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="8">6</td>
                            <td rowspan="8">
                              Apakah ada kegiatan Sosialisasi Perda atau Perkada
                              terkait penyusunan RDTR Digital?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penilaian ada tidaknya sosialisasi Perda atau
                              Perkada terkait penyusunan RDTR dilakukan dengan
                              ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a6_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Sosialisasi dilakukan sekurang-kurangnya 1
                                  kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a6_file1)"
                                v-if="vf.p2a6_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a6_file1_status == 'Sesuai'"
                                v-model="vf.p2a6_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a6_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a6_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a6_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a6_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a6_file2)"
                                v-if="vf.p2a6_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a6_file2_status == 'Sesuai'"
                                v-model="vf.p2a6_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a6_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a6_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a6_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a6_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a6_file3)"
                                v-if="vf.p2a6_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a6_file3_status == 'Sesuai'"
                                v-model="vf.p2a6_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a6_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a6_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a6_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a6_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat notula sosialisasi
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a6_file4)"
                                v-if="vf.p2a6_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a6_file4_status == 'Sesuai'"
                                v-model="vf.p2a6_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a6_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a6_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a6_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a6_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a6_file5)"
                                v-if="vf.p2a6_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a6_file5_status == 'Sesuai'"
                                v-model="vf.p2a6_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a6_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a6_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a6_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2a6_file6 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Kegiatan sosialisasi dipublikasikan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2a6_file6)"
                                v-if="vf.p2a6_file6 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2a6_file6_status == 'Sesuai'"
                                v-model="vf.p2a6_file6_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2a6_file6_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2a6_file6_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2a6_file6_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div class="row" style="color: white">
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 32 ayat (2), dan Pasal 39 ayat (1)
                                      PP No. 6 Tahun 2021 tentang
                                      Penyelenggaraan Perizinan Berusaha di
                                      Daerah, Pemda wajib menyesuaikan Perda dan
                                      Perkada paling lama 2 (dua) bulan
                                      terhitung sejak PP No. 6 Tahun 2021
                                      diundangkan. Perda dan Perkada dimaksud
                                      adalah
                                    </div>
                                    <div class="col-12">
                                      a. Perda mengenai Rencana Tata Ruang
                                      Wilayah (RTRW)
                                    </div>
                                    <div class="col-12">
                                      b. Perkada mengenai Rencana Detail Tata
                                      Ruang (RDTR)
                                    </div>
                                  </div>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <!-- Hide 2026 -->

                          <template v-if="$route.query.type === 'kabkot'">
                          <tr>
                            <td colspan="5" style="background-color: #ebedf3">
                              <b
                                >Peraturan daerah atau Peraturan kepala Daerah
                                terkait persetujuan lingkungan dan
                                pengawasannya</b
                              >
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="2">1</td>
                            <td rowspan="2">
                              Apakah ada Perda dan atau Perkada di dalam dokumen
                              Prolegda?
                            </td>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Penilaian keberadaan Perkada dalam program
                                  pembentukan peraturan kepala daerah
                                  (Propemperkada) dilakukan dengan ketentuan
                                  <div class="row">
                                    <div class="col-1">a.</div>
                                    <div class="col-11">
                                      Kepala daerah menerbitkan peraturan kepala
                                      daerah mengenai pendelegasian kewenangan
                                      penyelenggaraan persetujuan lingkungan
                                      kepada Kepala DPMPTSP
                                    </div>
                                    <div class="col-1">b.</div>
                                    <div class="col-11">
                                      Kepala daerah menerbitkan peraturan kepala
                                      daerah mengenai pendelegasian kewenangan
                                      penyelenggaraan persetujuan lingkungan
                                      kepada Dinas Lingkungan Hidup
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b1_file1)"
                                v-if="vf.p2b1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b1_file1_status == 'Sesuai'"
                                v-model="vf.p2b1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b1_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Keberadaan Perkada berdasarkan Pasal 1 angka
                                    4 PP No. 22 Tahun 2021 tentang
                                    Penyelenggaraan Perlindungan dan Pengelolaan
                                    Lingkungan Hidup, Persetujuan Lingkungan
                                    adalah Keputusan Kelayakan Lingkungan Hidup
                                    atau Pernyataan Kesanggupan Pengelolaan
                                    Lingkungan Hidup yang telah mendapatkan
                                    persetujuan dari pemerintah pusat atau
                                    pemerintah daerah.
                                  </p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada” apabila salah satu ketentuan
                                    di atas terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila ketentuan di
                                    atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">2</td>
                            <td rowspan="7">
                              Apakah ada Konsultasi pengusulan Perda dan Perkada
                              dengan OPD daerah?
                            </td>
                            <td colspan="2" style="text-align: justify">
                              Keberadaan Perkada berdasarkan Pasal 1 angka 4 PP
                              No. 22 Tahun 2021 tentang Penyelenggaraan
                              Perlindungan dan Pengelolaan Lingkungan Hidup,
                              Persetujuan Lingkungan adalah Keputusan Kelayakan
                              Lingkungan Hidup atau Pernyataan Kesanggupan
                              Pengelolaan Lingkungan Hidup yang telah
                              mendapatkan persetujuan dari pemerintah pusat atau
                              pemerintah daerah. Penilaian konsultasi pengusulan
                              Perkada dengan OPD teknis dilakukan dengan
                              ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b2_file1)"
                                v-if="vf.p2b2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b2_file1_status == 'Sesuai'"
                                v-model="vf.p2b2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b2_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b2_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b2_file2)"
                                v-if="vf.p2b2_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b2_file2_status == 'Sesuai'"
                                v-model="vf.p2b2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b2_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b2_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b2_file3)"
                                v-if="vf.p2b2_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b2_file3_status == 'Sesuai'"
                                v-model="vf.p2b2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b2_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b2_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b2_file4)"
                                v-if="vf.p2b2_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b2_file4_status == 'Sesuai'"
                                v-model="vf.p2b2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b2_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b2_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b2_file5)"
                                v-if="vf.p2b2_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b2_file5_status == 'Sesuai'"
                                v-model="vf.p2b2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b2_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">3</td>
                            <td rowspan="7">
                              Apakah ada Konsultasi pengusulan Perda dan Perkada
                              dengan Kementerian Dalam Negeri, Kementerian
                              Investasi, dan Kementerian Teknis lainnya?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Keberadaan Perkada berdasarkan Pasal 1 angka 4 PP
                              No. 22 Tahun 2021 tentang Penyelenggaraan
                              Perlindungan dan Pengelolaan Lingkungan Hidup,
                              Persetujuan Lingkungan adalah Keputusan Kelayakan
                              Lingkungan Hidup atau Pernyataan Kesanggupan
                              Pengelolaan Lingkungan Hidup yang telah
                              mendapatkan persetujuan dari pemerintah pusat atau
                              pemerintah daerah. Penilaian konsultasi pengusulan
                              Perkada dengan Kementerian Dalam Negeri,
                              Kementerian Investasi/BKPM dan Kementerian Teknis
                              lainnya dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b3_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b3_file1)"
                                v-if="vf.p2b3_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b3_file1_status == 'Sesuai'"
                                v-model="vf.p2b3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b3_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b3_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b3_file2)"
                                v-if="vf.p2b3_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b3_file2_status == 'Sesuai'"
                                v-model="vf.p2b3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b3_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b3_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b3_file3)"
                                v-if="vf.p2b3_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b3_file3_status == 'Sesuai'"
                                v-model="vf.p2b3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b3_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b3_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b3_file4)"
                                v-if="vf.p2b3_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b3_file4_status == 'Sesuai'"
                                v-model="vf.p2b3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b3_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b3_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b3_file5)"
                                v-if="vf.p2b3_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b3_file5_status == 'Sesuai'"
                                v-model="vf.p2b3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b3_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">4</td>
                            <td rowspan="7">
                              Apakah ada koordinasi pengusulan Perda dan Perkada
                              dengan Kementrian Dalam Negeri, Kementrian
                              Investasi, dan Kementrian Teknis lainnya?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Keberadaan Perkada berdasarkan Pasal 1 angka 4 PP
                              No. 22 Tahun 2021 tentang Penyelenggaraan
                              Perlindungan dan Pengelolaan Lingkungan Hidup,
                              Persetujuan Lingkungan adalah Keputusan Kelayakan
                              Lingkungan Hidup atau Pernyataan Kesanggupan
                              Pengelolaan Lingkungan Hidup yang telah
                              mendapatkan persetujuan dari pemerintah pusat atau
                              pemerintah daerah. Penilaian koordinasi pengusulan
                              Perkada dengan Kementerian Dalam Negeri,
                              Kementerian Investasi/BKPM dan Kementerian Teknis
                              lainnya dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b4_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b4_file1)"
                                v-if="vf.p2b4_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b4_file1_status == 'Sesuai'"
                                v-model="vf.p2b4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b4_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b4_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b4_file2)"
                                v-if="vf.p2b4_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b4_file2_status == 'Sesuai'"
                                v-model="vf.p2b4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b4_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b4_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b4_file3)"
                                v-if="vf.p2b4_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b4_file3_status == 'Sesuai'"
                                v-model="vf.p2b4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b4_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b4_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b4_file4)"
                                v-if="vf.p2b4_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b4_file4_status == 'Sesuai'"
                                v-model="vf.p2b4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b4_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b4_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b4_file5)"
                                v-if="vf.p2b4_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b4_file5_status == 'Sesuai'"
                                v-model="vf.p2b4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b4_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="2">5</td>
                            <td rowspan="2">
                              Apakah ada dokumen Peraturan Daerah atau Peraturan
                              Kepala Daerah terkait pengawasan dan perizinan
                              lingkungan?
                            </td>
                            <td>
                              <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio
                                  disabled
                                  v-model="vf.p2b5_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2b5_nilai"
                                  value="25"
                                  >Ada, sudah disahkan</b-form-radio
                                >
                                <b-form-radio
                                  disabled
                                  v-model="vf.p2b5_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2b5_nilai"
                                  value="10"
                                  >Ada, belum disahkan</b-form-radio
                                >
                                <b-form-radio
                                  disabled
                                  v-model="vf.p2b5_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2b5_nilai"
                                  value="0"
                                  >Belum ada</b-form-radio
                                >
                              </b-form-group>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b5_file1)"
                                v-if="vf.p2b5_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b5_nilai_status == 'Sesuai'"
                                v-model="vf.p2b5_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b5_nilai_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b5_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b5_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div class="row" style="color: white">
                                    <div class="col-12">
                                      Keberadaan Perkada berdasarkan Pasal 1
                                      angka 4 PP No. 22 Tahun 2021 tentang
                                      Penyelenggaraan Perlindungan dan
                                      Pengelolaan Lingkungan Hidup, Persetujuan
                                      Lingkungan adalah Keputusan Kelayakan
                                      Lingkungan Hidup atau Pernyataan
                                      Kesanggupan Pengelolaan Lingkungan Hidup
                                      yang telah mendapatkan persetujuan dari
                                      pemerintah pusat atau pemerintah daerah.
                                      Penilaian ada tidaknya Peraturan Kepala
                                      Daerah terkait pengawasan dan perizinan
                                      lingkungan dilakukan dengan ketentuan
                                    </div>
                                    <div class="col-12">
                                      1. Kepala daerah menerbitkan peraturan
                                      kepala daerah mengenai pendelegasian
                                      kewenangan penyelenggaraan persetujuan
                                      lingkungan kepada Kepala DPMPTSP dalam
                                      lembaran daerah
                                    </div>
                                    <div class="col-12">
                                      2. Kepala daerah menerbitkan peraturan
                                      kepala daerah mengenai pendelegasian
                                      kewenangan penyelenggaraan persetujuan
                                      lingkungan kepada Dinas Lingkungan Hidup
                                      dalam lembaran daerah
                                    </div>
                                  </div>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, sudah disahkan” apabila salah
                                    satu ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, belum disahkan” apabila
                                    seluruh ketentuan di atas tidak terpenuhi
                                    namun sudah tersedia dalam bentuk
                                    naskah/dokumen usulan. <br />
                                    3. Nilai “Belum ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">6</td>
                            <td rowspan="7">
                              Apakah ada Sosialisasi Perda atau Perkada terkait
                              pengawasan dan perizinan lingkungan?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Keberadaan Perkada berdasarkan Pasal 1 angka 4 PP
                              No. 22 Tahun 2021 tentang Penyelenggaraan
                              Perlindungan dan Pengelolaan Lingkungan Hidup,
                              Persetujuan Lingkungan adalah Keputusan Kelayakan
                              Lingkungan Hidup atau pernyataan Kesanggupan
                              Pengelolaan Lingkungan Hidup yang telah
                              mendapatkan persetujuan dari pemerintah pusat atau
                              pemerintah daerah. Penilaian ada tidaknya
                              sosialisasi Perkada terkait pengawasan dan
                              perizinan lingkungan dilakukan dengan ketentuan
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b6_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Sosialisasi dilakukan sekurang-kurangnya 1
                                  kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b6_file1)"
                                v-if="vf.p2b6_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b6_file1_status == 'Sesuai'"
                                v-model="vf.p2b6_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b6_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b6_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b6_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b6_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b6_file2)"
                                v-if="vf.p2b6_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b6_file2_status == 'Sesuai'"
                                v-model="vf.p2b6_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b6_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b6_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b6_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b6_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b6_file3)"
                                v-if="vf.p2b6_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b6_file3_status == 'Sesuai'"
                                v-model="vf.p2b6_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b6_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b6_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b6_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b6_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat notula sosialisasi
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b6_file4)"
                                v-if="vf.p2b6_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b6_file4_status == 'Sesuai'"
                                v-model="vf.p2b6_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b6_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b6_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b6_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2b6_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2b6_file5)"
                                v-if="vf.p2b6_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2b6_file5_status == 'Sesuai'"
                                v-model="vf.p2b6_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2b6_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2b6_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2b6_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5" style="background-color: #ebedf3">
                              <b
                                >Peraturan daerah atau Peraturan kepala daerah
                                terkait persetujuan bangunan gedung melalui
                                sistem elektronik, pengawasan pelaksanaan
                                konstruksi bangunan Gedung, dan pembinaan
                                bangunan Gedung</b
                              >
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="2">1</td>
                            <td rowspan="2">
                              Apakah ada Perda atau Perkada dalam dokumen
                              Prolegda?
                            </td>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Penilaian keberadaan Perda dalam program
                                  pembentukan peraturan daerah (Propemperda)
                                  dan/atau Perkada dalam program pembentukan
                                  peraturan kepala daerah (Propemperkada)
                                  dilakukan dengan ketentuan
                                  <div class="row">
                                    <div class="col-1">a.</div>
                                    <div class="col-11">
                                      Dokumen Perda mengenai Retribusi
                                      Persetujuan Bangunan Gedung dalam
                                      Propemperda; dan/atau
                                    </div>
                                    <div class="col-1">b.</div>
                                    <div class="col-11">
                                      Dokumen Perkada mengenai tata cara
                                      penyelenggaraan PBG dan Sertifikat Laik
                                      Fungsi (SLF) melalui Sistem Informasi
                                      Manajemen Bangunan Gedung (SIMBG) dalam
                                      Propemperkada
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c1_file1)"
                                v-if="vf.p2c1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c1_file1_status == 'Sesuai'"
                                v-model="vf.p2c1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c1_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div
                                    class="row"
                                    style="color: white; text-align: justify"
                                  >
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 347 ayat (2) PP No. 16 Tahun 2021
                                      tentang Peraturan Pelaksanaan
                                      Undang-Undang Nomor 28 Tahun 2002 Tentang
                                      Bangunan Gedung, Pemerintah kabupaten/kota
                                      wajib menyediakan Persetujuan Bangunan
                                      Gedung (PBG) paling lama 6 (enam) bulan
                                      terhitung sejak PP No. 16 Tahun 2021
                                      diundangkan melalui penetapan:
                                    </div>
                                    <div class="col-12">
                                      1. Peraturan daerah mengenai Retribusi
                                      Persetujuan Bangunan Gedung; dan/atau
                                    </div>
                                    <div class="col-12">
                                      2. Peraturan kepala daerah mengenai tata
                                      cara penyelenggaraan PBG dan Sertifikat
                                      Laik Fungsi (SLF) melalui Sistem Informasi
                                      Manajemen Bangunan Gedung (SIMBG)
                                    </div>
                                  </div>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada” apabila dapat menunjukkan
                                    naskah/dokumen usulan perda mengenai
                                    Retribusi PBG dan Perkada mengenai tata cara
                                    penyelenggaraan PBG dan SLF melalui Sistem
                                    Informasi Manajemen Bangunan Gedung
                                    (SIMBG).<br />
                                    2. Nilai “Tidak ada” apabila ketentuan di
                                    atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">2</td>
                            <td rowspan="7">
                              Apakah ada Konsultasi pengusulan Perda dan Perkada
                              dengan OPD daerah?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penyusunan Perda dan Perkada berdasarkan Pasal 347
                              ayat (2) PP No. 16 Tahun 2021 tentang Peraturan
                              Penilaian konsultasi pengusulan Perda dan Perkada
                              dengan OPD dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c2_file1)"
                                v-if="vf.p2c2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c2_file1_status == 'Sesuai'"
                                v-model="vf.p2c2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c2_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c2_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c2_file2)"
                                v-if="vf.p2c2_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c2_file2_status == 'Sesuai'"
                                v-model="vf.p2c2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c2_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c2_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c2_file3)"
                                v-if="vf.p2c2_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c2_file3_status == 'Sesuai'"
                                v-model="vf.p2c2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c2_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c2_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat notula sosialisasi
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c2_file4)"
                                v-if="vf.p2c2_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c2_file4_status == 'Sesuai'"
                                v-model="vf.p2c2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c2_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c2_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c2_file5)"
                                v-if="vf.p2c2_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c2_file5_status == 'Sesuai'"
                                v-model="vf.p2c2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c2_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div class="row" style="color: white">
                                    <div class="col-12">
                                      Pelaksanaan Undang-Undang Nomor 28 Tahun
                                      2002 Tentang Bangunan Gedung, Pemerintah
                                      kabupaten/kota wajib menyediakan
                                      Persetujuan Bangunan Gedung (PBG) paling
                                      lama 6 (enam) bulan terhitung sejak PP No.
                                      16 Tahun 2021 diundangkan melalui
                                      penetapan
                                    </div>
                                    <div class="col-12">
                                      a. Peraturan daerah mengenai Retribusi
                                      Persetujuan Bangunan Gedung; dan/atau
                                    </div>
                                    <div class="col-12">
                                      b. Peraturan kepala daerah mengenai tata
                                      cara penyelenggaraan PBG dan Sertifikat
                                      Laik Fungsi (SLF) melalui Sistem Informasi
                                      Manajemen Bangunan Gedung (SIMBG)
                                    </div>
                                  </div>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">3</td>
                            <td rowspan="7">
                              Apakah ada pengusulan Perda dan Perkada dengan
                              Kementerian Dalam Negeri, Kementerian Investasi,
                              dan Kementerian Teknis lainnya?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penilaian konsultasi pengusulan Perda dan Perkada
                              dengan Kementerian Dalam Negeri, Kementerian
                              Investasi/BKPM dan Kementerian Teknis lainnya
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c3_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c3_file1)"
                                v-if="vf.p2c3_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c3_file1_status == 'Sesuai'"
                                v-model="vf.p2c3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c3_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c3_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c3_file2)"
                                v-if="vf.p2c3_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c3_file2_status == 'Sesuai'"
                                v-model="vf.p2c3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c3_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c3_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c3_file3)"
                                v-if="vf.p2c3_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c3_file3_status == 'Sesuai'"
                                v-model="vf.p2c3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c3_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c3_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c3_file4)"
                                v-if="vf.p2c3_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c3_file4_status == 'Sesuai'"
                                v-model="vf.p2c3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c3_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c3_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c3_file5)"
                                v-if="vf.p2c3_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c3_file5_status == 'Sesuai'"
                                v-model="vf.p2c3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c3_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div
                                    class="row"
                                    style="color: white; text-align: justify"
                                  >
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 347 ayat (2) PP No. 16 Tahun 2021
                                      tentang Peraturan Pelaksanaan
                                      Undang-Undang Nomor 28 Tahun 2002 Tentang
                                      Bangunan Gedung, Pemerintah kabupaten/kota
                                      wajib menyediakan Persetujuan Bangunan
                                      Gedung (PBG) paling lama 6 (enam) bulan
                                      terhitung sejak PP No. 16 Tahun 2021
                                      diundangkan melalui penetapan:
                                      <div class="col-12">
                                        a. Peraturan daerah mengenai Retribusi
                                        Persetujuan Bangunan Gedung; dan/atau
                                      </div>
                                      <div class="col-12">
                                        b. Peraturan kepala daerah mengenai tata
                                        cara penyelenggaraan PBG dan Sertifikat
                                        Laik Fungsi (SLF) melalui Sistem
                                        Informasi Manajemen Bangunan Gedung
                                        (SIMBG)
                                      </div>
                                    </div>
                                    <p style="color: white">
                                      Untuk penetapan bobot penilaian: <br />
                                      1. Nilai “Ada, lebih dari 1 kali” apabila
                                      kelima ketentuan di atas terpenuhi.<br />
                                      2. Nilai “Ada 1 kali” apabila salah satu
                                      dari ketentuan di atas tidak terpenuhi.
                                      <br />
                                      3. Nilai “Tidak ada” apabila seluruh
                                      ketentuan di atas tidak terpenuhi.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">4</td>
                            <td rowspan="7">
                              Apakah ada koordinasi pengusulan Perda dan Perkada
                              dengan Kementerian Dalam Negeri, Kementerian
                              Investasi, dan Kementerian Teknis lainnya?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penilaian koordinasi pengusulan Perda dan Perkada
                              dengan Kementerian Dalam Negeri, Kementerian
                              Investasi/BKPM dan Kementerian Teknis lainnya
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c4_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Koordinasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c4_file1)"
                                v-if="vf.p2c4_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c4_file1_status == 'Sesuai'"
                                v-model="vf.p2c4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c4_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c4_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c4_file2)"
                                v-if="vf.p2c4_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c4_file2_status == 'Sesuai'"
                                v-model="vf.p2c4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c4_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c4_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c4_file3)"
                                v-if="vf.p2c4_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c4_file3_status == 'Sesuai'"
                                v-model="vf.p2c4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c4_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c4_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c4_file4)"
                                v-if="vf.p2c4_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c4_file4_status == 'Sesuai'"
                                v-model="vf.p2c4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c4_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c4_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c4_file5)"
                                v-if="vf.p2c4_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c4_file5_status == 'Sesuai'"
                                v-model="vf.p2c4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c4_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div
                                    class="row"
                                    style="color: white; text-align: justify"
                                  >
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 347 ayat (2) PP No. 16 Tahun 2021
                                      tentang Peraturan Pelaksanaan
                                      Undang-Undang Nomor 28 Tahun 2002 Tentang
                                      Bangunan Gedung, Pemerintah kabupaten/kota
                                      wajib menyediakan Persetujuan Bangunan
                                      Gedung (PBG) paling lama 6 (enam) bulan
                                      terhitung sejak PP No. 16 Tahun 2021
                                      diundangkan melalui penetapan:
                                      <div class="col-12">
                                        a. Peraturan daerah mengenai Retribusi
                                        Persetujuan Bangunan Gedung; dan/atau
                                      </div>
                                      <div class="col-12">
                                        b. peraturan kepala daerah mengenai tata
                                        cara penyelenggaraan PBG dan Sertifikat
                                        Laik Fungsi (SLF) melalui Sistem
                                        Informasi Manajemen Bangunan Gedung
                                        (SIMBG)
                                      </div>
                                    </div>
                                    <p style="color: white">
                                      Untuk penetapan bobot penilaian: <br />
                                      1. Nilai “Ada, lebih dari 1 kali” apabila
                                      kelima ketentuan di atas terpenuhi.<br />
                                      2. Nilai “Ada 1 kali” apabila salah satu
                                      dari ketentuan di atas tidak terpenuhi.
                                      <br />
                                      3. Nilai “Tidak ada” apabila seluruh
                                      ketentuan di atas tidak terpenuhi.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="2">5</td>
                            <td rowspan="2">
                              Apakah ada dokumen Peraturan daerah atau Peraturan
                              Kepala Daerah terkait persetujuan bangunan Gedung
                              melalui sistem elektronik, pengawasan pelaksaan
                              konstruksi bangunan Gedung, dan pembinaan bangunan
                              Gedung?
                            </td>
                            <td>
                              <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio
                                  disabled
                                  v-model="vf.p2c5_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2c5_nilai"
                                  value="25"
                                  >Ada, sudah disahkan</b-form-radio
                                >
                                <b-form-radio
                                  disabled
                                  v-model="vf.p2c5_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2c5_nilai"
                                  value="10"
                                  >Ada, belum disahkan</b-form-radio
                                >
                                <b-form-radio
                                  disabled
                                  v-model="vf.p2c5_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2c5_nilai"
                                  value="0"
                                  >Belum ada</b-form-radio
                                >
                              </b-form-group>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c5_file1)"
                                v-if="vf.p2c5_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c5_nilai_status == 'Sesuai'"
                                v-model="vf.p2c5_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c5_nilai_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c5_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c5_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div class="row" style="color: white">
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 347 ayat (2) PP No. 16 Tahun 2021
                                      tentang Peraturan Pelaksanaan
                                      Undang-Undang Nomor 28 Tahun 2002 Tentang
                                      Bangunan Gedung, Pemerintah kabupaten/kota
                                      wajib menyediakan Persetujuan Bangunan
                                      Gedung (PBG) paling lama 6 (enam) bulan
                                      terhitung sejak PP No. 16 Tahun 2021
                                      diundangkan melalui penetapan:
                                    </div>
                                    <div class="col-12">
                                      a. Peraturan daerah mengenai Retribusi
                                      Persetujuan Bangunan Gedung; dan/atau
                                    </div>
                                    <div class="col-12">
                                      b. Peraturan kepala daerah mengenai tata
                                      cara penyelenggaraan PBG dan Sertifikat
                                      Laik Fungsi (SLF) melalui Sistem Informasi
                                      Manajemen Bangunan Gedung (SIMBG)
                                    </div>
                                  </div>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, sudah disahkan” apabila salah
                                    satu ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, belum disahkan” apabila
                                    menunjukkan naskah usulan Perda mengenai
                                    retribusi penyelenggaraan PBG dan/atau
                                    Perkada mengenai penyelenggaraan PBG. <br />
                                    3. Nilai “Belum ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">6</td>
                            <td rowspan="7">
                              Apakah ada kegiatan Sosialisasi Perda atau Perkada
                              terkait persetujuan bangunan Gedung melalu system
                              elektronik, pengawasan pelaksaan konstruksi
                              bangunan Gedung, dan pembinaan bangunan Gedung?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penilaian ada tidaknya sosialisasi Perda atau
                              Perkada terkait persetujuan bangunan gedung
                              melalui sistem elektronik, pengawasan pelaksanaan
                              konstruksi bangunan Gedung, dan pembinaan bangunan
                              Gedung dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c6_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Sosialisasi dilakukan sekurang-kurangnya 1
                                  kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c6_file1)"
                                v-if="vf.p2c6_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c6_file1_status == 'Sesuai'"
                                v-model="vf.p2c6_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c6_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c6_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c6_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c6_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c6_file2)"
                                v-if="vf.p2c6_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c6_file2_status == 'Sesuai'"
                                v-model="vf.p2c6_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c6_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c6_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c6_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c6_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c6_file3)"
                                v-if="vf.p2c6_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c6_file3_status == 'Sesuai'"
                                v-model="vf.p2c6_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c6_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c6_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c6_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c6_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat notula sosialisasi
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c6_file4)"
                                v-if="vf.p2c6_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c6_file4_status == 'Sesuai'"
                                v-model="vf.p2c6_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c6_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c6_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c6_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2c6_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2c6_file5)"
                                v-if="vf.p2c6_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2c6_file5_status == 'Sesuai'"
                                v-model="vf.p2c6_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2c6_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2c6_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2c6_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div
                                    class="row"
                                    style="color: white; text-align: justify"
                                  >
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 347 ayat (2) PP No. 16 Tahun 2021
                                      tentang Peraturan Pelaksanaan
                                      Undang-Undang Nomor 28 Tahun 2002 Tentang
                                      Bangunan Gedung, Pemerintah kabupaten/kota
                                      wajib menyediakan Persetujuan Bangunan
                                      Gedung (PBG) paling lama 6 (enam) bulan
                                      terhitung sejak PP No. 16 Tahun 2021
                                      diundangkan melalui penetapan:
                                      <div class="col-12">
                                        a. Peraturan daerah mengenai Retribusi
                                        Persetujuan Bangunan Gedung; dan/atau
                                      </div>
                                      <div class="col-12">
                                        b. Peraturan kepala daerah mengenai tata
                                        cara penyelenggaraan PBG dan Sertifikat
                                        Laik Fungsi (SLF) melalui Sistem
                                        Informasi Manajemen Bangunan Gedung
                                        (SIMBG)
                                      </div>
                                    </div>
                                    <p style="color: white">
                                      Untuk penetapan bobot penilaian: <br />
                                      1. Nilai “Ada, lebih dari 1 kali” apabila
                                      kelima ketentuan di atas terpenuhi.<br />
                                      2. Nilai “Ada 1 kali” apabila salah satu
                                      dari ketentuan di atas tidak terpenuhi.
                                      <br />
                                      3. Nilai “Tidak ada” apabila seluruh
                                      ketentuan di atas tidak terpenuhi.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="5" style="background-color: #ebedf3">
                              <b
                                >Peraturan daerah atau Peraturan kepala Daerah
                                terkait penerbitan Sertifikat Laik Fungsi
                                melalui sistem elektronik</b
                              >
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="4">1</td>
                            <td rowspan="4">
                              Apakah ada Perda dan/atau Perkada dalam dokumen
                              Prolegda?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penilaian keberadaan Perda dan atau Perkada
                              dokumen program pembentukan peraturan daerah
                              (Propemperda) atau program pembentukan peraturan
                              kepala daerah (Propemperkada) dilakukan dengan
                              ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Dokumen Perda mengenai Retribusi Persetujuan
                                  Bangunan Gedung dalam Propemperda
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d1_file1)"
                                v-if="vf.p2d1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d1_file1_status == 'Sesuai'"
                                v-model="vf.p2d1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d1_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Dokumen Perkada mengenai tata cara
                                  penyelenggaraan PBG dan Sertifikat Laik Fungsi
                                  (SLF) melalui Sistem Informasi Manajemen
                                  Bangunan Gedung (SIMBG) dalam Propemperkada
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d1_file2)"
                                v-if="vf.p2d1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d1_file2_status == 'Sesuai'"
                                v-model="vf.p2d1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d1_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div
                                    class="row"
                                    style="color: white; text-align: justify"
                                  >
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 347 ayat (2) PP No. 16 Tahun 2021
                                      tentang Peraturan Pelaksanaan
                                      Undang-Undang Nomor 28 Tahun 2002 Tentang
                                      Bangunan Gedung, Pemerintah kabupaten/kota
                                      wajib menyediakan Persetujuan Bangunan
                                      Gedung (PBG) paling lama 6 (enam) bulan
                                      terhitung sejak PP No. 16 Tahun 2021
                                      diundangkan melalui penetapan:
                                      <div class="col-12">
                                        1. Peraturan daerah mengenai Retribusi
                                        Persetujuan Bangunan Gedung
                                      </div>
                                      <div class="col-12">
                                        2. Peraturan kepala daerah mengenai tata
                                        cara penyelenggaraan PBG dan Sertifikat
                                        Laik Fungsi (SLF) melalui Sistem
                                        Informasi Manajemen Bangunan Gedung
                                        (SIMBG)
                                      </div>
                                    </div>
                                    <p style="color: white">
                                      Untuk penetapan bobot penilaian: <br />
                                      1. Nilai “Ada” apabila seluruh ketentuan
                                      di atas terpenuhi.<br />
                                      2. Nilai “Tidak ada” apabila ketentuan di
                                      atas tidak terpenuhi.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">2</td>
                            <td rowspan="7">
                              Apakah ada konsultasi pengusulan Perda dan Perkada
                              dengan OPD Daerah?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penilaian konsultasi pengusulan Perda dan Perkada
                              dengan OPD dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d2_file1)"
                                v-if="vf.p2d2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d2_file1_status == 'Sesuai'"
                                v-model="vf.p2d2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d2_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d2_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d2_file2)"
                                v-if="vf.p2d2_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d2_file2_status == 'Sesuai'"
                                v-model="vf.p2d2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d2_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d2_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d2_file3)"
                                v-if="vf.p2d2_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d2_file3_status == 'Sesuai'"
                                v-model="vf.p2d2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d2_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d2_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d2_file4)"
                                v-if="vf.p2d2_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d2_file4_status == 'Sesuai'"
                                v-model="vf.p2d2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d2_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d2_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d2_file5)"
                                v-if="vf.p2d2_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d2_file5_status == 'Sesuai'"
                                v-model="vf.p2d2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d2_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div
                                    class="row"
                                    style="color: white; text-align: justify"
                                  >
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 347 ayat (2) PP No. 16 Tahun 2021
                                      tentang Peraturan Pelaksanaan
                                      Undang-Undang Nomor 28 Tahun 2002 Tentang
                                      Bangunan Gedung, Pemerintah kabupaten/kota
                                      wajib menyediakan Persetujuan Bangunan
                                      Gedung (PBG) paling lama 6 (enam) bulan
                                      terhitung sejak PP No. 16 Tahun 2021
                                      diundangkan melalui penetapan:
                                      <div class="col-12">
                                        a. Peraturan daerah mengenai Retribusi
                                        Persetujuan Bangunan Gedung; dan/atau
                                      </div>
                                      <div class="col-12">
                                        b. Peraturan kepala daerah mengenai tata
                                        cara penyelenggaraan PBG dan Sertifikat
                                        Laik Fungsi (SLF) melalui Sistem
                                        Informasi Manajemen Bangunan Gedung
                                        (SIMBG)
                                      </div>
                                    </div>
                                    <p style="color: white">
                                      Untuk penetapan bobot penilaian: <br />
                                      1. Nilai “Ada, lebih dari 1 kali” apabila
                                      kelima ketentuan di atas terpenuhi.<br />
                                      2. Nilai “Ada 1 kali” apabila salah satu
                                      dari ketentuan di atas tidak terpenuhi.
                                      <br />
                                      3. Nilai “Tidak ada” apabila seluruh
                                      ketentuan di atas tidak terpenuhi.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">3</td>
                            <td rowspan="7">
                              Apakah ada konsultasi pengusulan Perda dan Perkada
                              dengan Kementerian Dalam Negeri, Kementerian
                              Investasi dan kementerian teknis lainnya ?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penilaian konsultasi pengusulan Perda dan Perkada
                              dengan Kementerian Dalam Negeri, Kementerian
                              Investasi/BKPM dan Kementerian Teknis lainnya
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d3_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d3_file1)"
                                v-if="vf.p2d3_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d3_file1_status == 'Sesuai'"
                                v-model="vf.p2d3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d3_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d3_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d3_file2)"
                                v-if="vf.p2d3_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d3_file2_status == 'Sesuai'"
                                v-model="vf.p2d3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d3_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d3_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d3_file3)"
                                v-if="vf.p2d3_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d3_file3_status == 'Sesuai'"
                                v-model="vf.p2d3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d3_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d3_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d3_file4)"
                                v-if="vf.p2d3_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d3_file4_status == 'Sesuai'"
                                v-model="vf.p2d3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d3_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d3_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d3_file5)"
                                v-if="vf.p2d3_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d3_file5_status == 'Sesuai'"
                                v-model="vf.p2d3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d3_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div
                                    class="row"
                                    style="color: white; text-align: justify"
                                  >
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 347 ayat (2) PP No. 16 Tahun 2021
                                      tentang Peraturan Pelaksanaan
                                      Undang-Undang Nomor 28 Tahun 2002 Tentang
                                      Bangunan Gedung, Pemerintah kabupaten/kota
                                      wajib menyediakan Persetujuan Bangunan
                                      Gedung (PBG) paling lama 6 (enam) bulan
                                      terhitung sejak PP No. 16 Tahun 2021
                                      diundangkan melalui penetapan:
                                      <div class="col-12">
                                        a. Peraturan daerah mengenai Retribusi
                                        Persetujuan Bangunan Gedung; dan/atau
                                      </div>
                                      <div class="col-12">
                                        b. Peraturan kepala daerah mengenai tata
                                        cara penyelenggaraan PBG dan Sertifikat
                                        Laik Fungsi (SLF) melalui Sistem
                                        Informasi Manajemen Bangunan Gedung
                                        (SIMBG)
                                      </div>
                                    </div>
                                    <p style="color: white">
                                      Untuk penetapan bobot penilaian: <br />
                                      1. Nilai “Ada, lebih dari 1 kali” apabila
                                      kelima ketentuan di atas terpenuhi.<br />
                                      2. Nilai “Ada 1 kali” apabila salah satu
                                      dari ketentuan di atas tidak terpenuhi.
                                      <br />
                                      3. Nilai “Tidak ada” apabila seluruh
                                      ketentuan di atas tidak terpenuhi.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">4</td>
                            <td rowspan="7">
                              Apakah ada koordinasi pengusulan Perda dan Perkada
                              dengan Kementerian Dalam Negeri, Kementerian
                              Investasi dan kementerian teknis lainnya?
                            </td>
                            <td colspan="2" style="text-align: justify">
                              Penilaian koordinasi pengusulan Perda dan Perkada
                              dengan Kementerian Dalam Negeri, Kementerian
                              Investasi/BKPM dan Kementerian Teknis lainnya
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d4_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Konsultasi dilakukan sekurang-kurangnya 1 kali
                                  dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d4_file1)"
                                v-if="vf.p2d4_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d4_file1_status == 'Sesuai'"
                                v-model="vf.p2d4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d4_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d4_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi (melibatkan
                                  pihak eksternal) dalam bentuk fisik atau
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d4_file2)"
                                v-if="vf.p2d4_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d4_file2_status == 'Sesuai'"
                                v-model="vf.p2d4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d4_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d4_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d4_file3)"
                                v-if="vf.p2d4_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d4_file3_status == 'Sesuai'"
                                v-model="vf.p2d4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d4_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d4_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d4_file4)"
                                v-if="vf.p2d4_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d4_file4_status == 'Sesuai'"
                                v-model="vf.p2d4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d4_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d4_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                  digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d4_file5)"
                                v-if="vf.p2d4_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d4_file5_status == 'Sesuai'"
                                v-model="vf.p2d4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d4_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div
                                    class="row"
                                    style="color: white; text-align: justify"
                                  >
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 347 ayat (2) PP No. 16 Tahun 2021
                                      tentang Peraturan Pelaksanaan
                                      Undang-Undang Nomor 28 Tahun 2002 Tentang
                                      Bangunan Gedung, Pemerintah kabupaten/kota
                                      wajib menyediakan Persetujuan Bangunan
                                      Gedung (PBG) paling lama 6 (enam) bulan
                                      terhitung sejak PP No. 16 Tahun 2021
                                      diundangkan melalui penetapan:
                                      <div class="col-12">
                                        a. Peraturan daerah mengenai Retribusi
                                        Persetujuan Bangunan Gedung dan atau
                                      </div>
                                      <div class="col-12">
                                        b. Peraturan kepala daerah mengenai tata
                                        cara penyelenggaraan PBG dan Sertifikat
                                        Laik Fungsi (SLF) melalui Sistem
                                        Informasi Manajemen Bangunan Gedung
                                        (SIMBG)
                                      </div>
                                    </div>
                                    <p style="color: white">
                                      Untuk penetapan bobot penilaian: <br />
                                      1. Nilai “Ada, lebih dari 1 kali” apabila
                                      kelima ketentuan di atas terpenuhi.<br />
                                      2. Nilai “Ada 1 kali” apabila salah satu
                                      dari ketentuan di atas tidak terpenuhi.
                                      <br />
                                      3. Nilai “Tidak ada” apabila seluruh
                                      ketentuan di atas tidak terpenuhi.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="3">5</td>
                            <td rowspan="3">
                              Apakah ada dokumen Peraturan Daerah atau Peraturan
                              Kepala Daerah terkait penerbitan Sertifikat Laik
                              Fungsi melalui sistem elektronik?
                            </td>
                            <td rowspan="2">
                              <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio
                                  disabled
                                  v-model="vf.p2d5_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2d5_nilai"
                                  value="25"
                                  >Ada, sudah disahkan</b-form-radio
                                >
                                <b-form-radio
                                  disabled
                                  v-model="vf.p2d5_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2d5_nilai"
                                  value="10"
                                  >Ada, belum disahkan</b-form-radio
                                >
                                <b-form-radio
                                  disabled
                                  v-model="vf.p2d5_nilai"
                                  :aria-describedby="ariaDescribedby"
                                  name="p2d5_nilai"
                                  value="0"
                                  >Belum ada</b-form-radio
                                >
                              </b-form-group>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d5_file1)"
                                v-if="vf.p2d5_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d5_nilai_status == 'Sesuai'"
                                v-model="vf.p2d5_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d5_nilai_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d5_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d5_nilai_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr colspan="3">
                            <td>
                              <button
                                @click="unduhFile(vf.p2d5_file2)"
                                v-if="vf.p2d5_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div
                                    class="row"
                                    style="color: white; text-align: justify"
                                  >
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 347 ayat (2) PP No. 16 Tahun 2021
                                      tentang Peraturan Pelaksanaan
                                      Undang-Undang Nomor 28 Tahun 2002 Tentang
                                      Bangunan Gedung, Pemerintah kabupaten/kota
                                      wajib menyediakan Persetujuan Bangunan
                                      Gedung (PBG) paling lama 6 (enam) bulan
                                      terhitung sejak PP No. 16 Tahun 2021
                                      diundangkan melalui penetapan:
                                      <div class="col-12">
                                        a. Peraturan daerah mengenai Retribusi
                                        Persetujuan Bangunan Gedung dan
                                      </div>
                                      <div class="col-12">
                                        b. Peraturan kepala daerah mengenai tata
                                        cara penyelenggaraan PBG dan Sertifikat
                                        Laik Fungsi (SLF) melalui Sistem
                                        Informasi Manajemen Bangunan Gedung
                                        (SIMBG)
                                      </div>
                                    </div>
                                    <p style="color: white">
                                      Untuk penetapan bobot penilaian: <br />
                                      1. Nilai “Ada, sudah disahkan” apabila
                                      seluruh ketentuan di atas terpenuhi.<br />
                                      2. Nilai “Ada, belum disahkan” apabila
                                      seluruh ketentuan di atas tidak terpenuhi
                                      namun sudah tersedia dalam bentuk
                                      naskah/dokumen usulan. <br />
                                      3. Nilai “Belum ada” apabila seluruh
                                      ketentuan di atas tidak terpenuhi.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">6</td>
                            <td rowspan="7" style="text-align: justify">
                              Penilaian ada tidaknya sosialisasi Perda atau
                              Perkada terkait penerbitan Sertifikat Laik Fungsi
                              melalui sistem elektronik dilakukan dengan
                              ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d6_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Sosialisasi dilakukan sekurang-kurangnya 1
                                  kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d6_file1)"
                                v-if="vf.p2d6_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d6_file1_status == 'Sesuai'"
                                v-model="vf.p2d6_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d6_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d6_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d6_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d6_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d6_file2)"
                                v-if="vf.p2d6_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d6_file2_status == 'Sesuai'"
                                v-model="vf.p2d6_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d6_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d6_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d6_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d6_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d6_file3)"
                                v-if="vf.p2d6_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d6_file3_status == 'Sesuai'"
                                v-model="vf.p2d6_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d6_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d6_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d6_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d6_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat notula sosialisasi
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d6_file4)"
                                v-if="vf.p2d6_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d6_file4_status == 'Sesuai'"
                                v-model="vf.p2d6_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d6_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d6_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d6_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2d6_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2d6_file5)"
                                v-if="vf.p2d6_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2d6_file5_status == 'Sesuai'"
                                v-model="vf.p2d6_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2d6_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2d6_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2d6_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div
                                    class="row"
                                    style="color: white; text-align: justify"
                                  >
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      Pasal 347 ayat (2) PP No. 16 Tahun 2021
                                      tentang Peraturan Pelaksanaan
                                      Undang-Undang Nomor 28 Tahun 2002 Tentang
                                      Bangunan Gedung, Pemerintah kabupaten/kota
                                      wajib menyediakan Persetujuan Bangunan
                                      Gedung (PBG) paling lama 6 (enam) bulan
                                      terhitung sejak PP No. 16 Tahun 2021
                                      diundangkan melalui penetapan:
                                      <div class="col-12">
                                        a. Peraturan daerah mengenai Retribusi
                                        Persetujuan Bangunan Gedung dan
                                      </div>
                                      <div class="col-12">
                                        b. Peraturan kepala daerah mengenai tata
                                        cara penyelenggaraan PBG dan Sertifikat
                                        Laik Fungsi (SLF) melalui Sistem
                                        Informasi Manajemen Bangunan Gedung
                                        (SIMBG)
                                      </div>
                                    </div>
                                    <p style="color: white">
                                      Untuk penetapan bobot penilaian: <br />
                                      1. Nilai “Ada, lebih dari 1 kali” apabila
                                      kelima ketentuan di atas terpenuhi.<br />
                                      2. Nilai “Ada 1 kali” apabila salah satu
                                      dari ketentuan di atas tidak terpenuhi.
                                      <br />
                                      3. Nilai “Tidak ada” apabila seluruh
                                      ketentuan di atas tidak terpenuhi.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>

                          </template>

                          <tr>
                            <td colspan="5" style="background-color: #ebedf3">
                              <b>Monitoring dan Evaluasi</b>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">1</td>
                            <td rowspan="7">
                              Apakah ada kegiatan monitoring dan evaluasi
                              kegiatan penyederhanaan persyaratan dasar
                              Perizinan Berusaha?
                            </td>
                            <td colspan="3" style="text-align: justify">
                              Penilaian ada tidaknya kegiatan monitoring dan
                              evaluasi kegiatan penyederhanaan persyaratan dasar
                              Perizinan Berusaha dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2e1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Kegiatan monitoring dan evaluasi dilakukan
                                  sekurang-kurangnya 1 kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2e1_file1)"
                                v-if="vf.p2e1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2e1_file1_status == 'Sesuai'"
                                v-model="vf.p2e1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2e1_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2e1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2e1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2e1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2e1_file2)"
                                v-if="vf.p2e1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2e1_file2_status == 'Sesuai'"
                                v-model="vf.p2e1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2e1_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2e1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2e1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2e1_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2e1_file3)"
                                v-if="vf.p2e1_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2e1_file3_status == 'Sesuai'"
                                v-model="vf.p2e1_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2e1_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2e1_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2e1_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2e1_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat notula sosialisasi
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2e1_file4)"
                                v-if="vf.p2e1_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2e1_file4_status == 'Sesuai'"
                                v-model="vf.p2e1_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2e1_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2e1_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2e1_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2e1_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2e1_file5)"
                                v-if="vf.p2e1_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2e1_file5_status == 'Sesuai'"
                                v-model="vf.p2e1_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2e1_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2e1_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2e1_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <div
                                    class="row"
                                    style="color: white; text-align: justify"
                                  >
                                    <div class="col-12">
                                      Penyusunan Perda dan Perkada berdasarkan
                                      PP No. 6 Tahun 2021 tentang
                                      Penyelenggaraan Perizinan Berusaha di
                                      Daerah, PP No. 22 Tahun 2021 tentang
                                      Penyelenggaraan Perlindungan dan
                                      Pengelolaan Lingkungan Hidup, dan PP No.
                                      16 Tahun 2021 tentang Peraturan
                                      Pelaksanaan Undang-Undang Nomor 28 Tahun
                                      2002 Tentang Bangunan Gedung, Pemda wajib
                                      melakukan kegiatan monitoring dan evaluasi
                                      kegiatan penyederhanaan persyaratan dasar
                                      Perizinan Berusaha yakni:
                                      <div class="col-12">
                                        1. Perda mengenai Rencana Tata Ruang
                                        Wilayah (RTRW)
                                      </div>
                                      <div class="col-12">
                                        2. Perkada mengenai Rencana Detail Tata
                                        Ruang (RDTR)
                                      </div>
                                      <div class="col-12">
                                        3. Perkada mengenai pendelegasian
                                        kewenangan penyelenggaraan perizinan
                                        berusaha kepada Kepala DPMPTSP
                                      </div>
                                      <div class="col-12">
                                        4. Perkada mengenai pendelegasian
                                        kewenangan penyelenggaraan persetujuan
                                        lingkungan kepada Kepala DPMPTSP atau
                                        Kepala Dinas Lingkungan Hidup
                                      </div>
                                      <div class="col-12">
                                        5. Perda mengenai retribusi PBG
                                      </div>
                                      <div class="col-12">
                                        6. Perkada mengenai tata cara
                                        penyelenggaraan PBG dan Sertifikat Laik
                                        Fungsi (SLF) melalui Sistem Informasi
                                        Manajemen Bangunan Gedung (SIMBG)
                                      </div>
                                    </div>
                                    <p style="color: white">
                                      Untuk penetapan bobot penilaian: <br />
                                      1. Nilai “Ada, teragenda” apabila kelima
                                      ketentuan di atas terpenuhi<br />
                                      2. Nilai “Ada, tidak teragenda” apabila
                                      salah satu dari ketentuan di atas tidak
                                      terpenuhi. <br />
                                      3. Nilai “Tidak ada” apabila seluruh
                                      ketentuan di atas tidak terpenuhi.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="2">2</td>
                            <td rowspan="2">
                              Apakah ada laporan kinerja penyederhanaan
                              persyaratan dasar Perizinan Berusaha?
                            </td>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p2e2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  Penilaian ada tidaknya laporan kinerja
                                  penyederhanaan persyaratan dasar Perizinan
                                  Berusaha dilakukan dengan ketentuan apabila
                                  laporan kinerja penyederhanaan persyaratan
                                  dasar Perizinan Berusaha dibuat secara formal
                                  dalam bentuk dokumen laporan lengkap fisik
                                  atau digital, bukan bahan presentasi dan
                                  sejenisnya
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p2e2_file1)"
                                v-if="vf.p2e2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p2e2_file1_status == 'Sesuai'"
                                v-model="vf.p2e2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p2e2_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p2e2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p2e2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada” apabila ketentuan di atas
                                    terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila ketentuan di
                                    atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div v-if="pm.catatan_2_surveyor != null">
                        <div class="card text-white bg-primary mb-3">
                          <!-- <div class="card-header">Header</div> -->
                          <div class="card-body">
                            <h5 class="card-title">
                              <i
                                class="fa fa-info-circle"
                                style="color: white"
                                aria-hidden="true"
                              ></i>
                              Catatan
                            </h5>
                            <hr />
                            <div
                              class="card-text"
                              v-html="pm.catatan_2_surveyor"
                            ></div>
                            <!-- <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> -->
                          </div>
                        </div>
                      </div>
                      <br />
                      <div v-if="pm.catatan_2_bkpm != null">
                        <div
                          class="card text-white bg-danger mb-3"
                          v-if="
                            (user.id_role === 'dpb' || user.id_role === 'kspb') ||
                            user.id_role === 'super_user'
                          "
                        >
                          <!-- <div class="card-header">Header</div> -->
                          <div class="card-body">
                            <h5 class="card-title">
                              <i
                                class="fa fa-info-circle"
                                style="color: white"
                                aria-hidden="true"
                              ></i>
                              Catatan dari BKPM
                            </h5>
                            <hr />
                            <div
                              class="card-text"
                              v-html="pm.catatan_2_bkpm"
                            ></div>
                            <!-- <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> -->
                          </div>
                        </div>
                      </div>
                      <br />
                      <div
                        v-if="
                          (user.id_role === 'dpb' || user.id_role === 'kspb') ||
                          user.id_role === 'super_user'
                        "
                        class="form-group row"
                      >
                        <label class="col-lg-12 col-form-label"
                          ><b>Catatan untuk surveyor</b></label
                        >
                      </div>
                      <div
                        v-if="
                          (user.id_role === 'dpb' || user.id_role === 'kspb') ||
                          user.id_role === 'super_user'
                        "
                        class="form-group row"
                      >
                        <div class="col-lg-12">
                          <vue-editor v-model="pm.catatan_2_bkpm" />
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-6"></div>
                        <div class="col-6">
                          <button
                            type="button"
                            v-if="
                              (user.id_role === 'dpb' || user.id_role === 'kspb') ||
                              user.id_role === 'super_user'
                            "
                            style="float: right"
                            @click="dokumenpenerapanperizinan"
                            class="btn btn-success font-weight-bolder text-uppercase px-9 py-4"
                          >
                            <i class="fas fa-save"></i>Kirim
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--end: Wizard Step 2-->

                  <!--begin: Wizard Step 3-->
                  <div class="pb-5" data-wizard-type="step-content">
                    <div v-if="pm.catatan_3_surveyor != null">
                      <b-alert show variant="danger"
                        >Terdapat catatan, silahkan lihat catatan
                        dibawah!</b-alert
                      >
                    </div>
                    <div
                      style="background-color: #1bc5bd"
                      class="card card-custom"
                    >
                      <div class="card-body text-green">
                        <h3 class="card-label" style="color: white">
                          <i
                            class="fa fa-info-circle"
                            style="color: white"
                            aria-hidden="true"
                          ></i>
                          Penting!
                        </h3>
                        <hr />
                        <p style="color: white">
                          Input data yang berkaitan dengan Peningkatan Iklim
                          Investasi berdasarkan fakta yang ada dengan memilih
                          data yang sesuai. Dokumen lampiran yang diunggah
                          adalah
                          <strong style="color: yellow">halaman depan</strong>
                          dan
                          <strong style="color: yellow"
                            >halaman pengesahan</strong
                          >
                          dokumen SOP, peraturan, dan lainnya. Ukuran file
                          setiap dokumen maksimal
                          <strong style="color: yellow">500KB</strong> dengan
                          format file
                          <strong style="color: yellow">*.pdf</strong>.
                        </p>
                      </div>
                    </div>
                    <br />
                    <div class="table-responsive-sm">
                      <table class="table">
                        <thead>
                          <tr class="table-active">
                            <th style="display: none">No</th>
                            <th style="display: none">Indikator</th>
                            <!-- <th style="display:none;">Status</th> -->
                            <th style="display: none">Jawaban</th>
                            <th style="display: none">Download</th>
                            <th style="display: none">Hasil</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colspan="5" style="background-color: #ebedf3">
                              <b>Perangkat Pelaksana PPB</b>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="4">1</td>
                            <td rowspan="4">
                              Apakah ada tim atau unit pelaksana PPB?
                            </td>
                            <td colspan="3">
                              Penilaian ketersediaan tim atau unit pelaksana PPB
                              dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p3a1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Pemda memiliki dan dapat menunjukkan
                                  penetapan/keputusan dari Kepala Daerah
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3a1_file1)"
                                v-if="vf.p3a1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3a1_file1_status == 'Sesuai'"
                                v-model="vf.p3a1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3a1_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3a1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3a1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p3a1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Pemda memiliki ruang sekretariat organisasi
                                  tim internal Pemda yang melaksanakan tugas dan
                                  fungsi PPB
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3a1_file2)"
                                v-if="vf.p3a1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3a1_file2_status == 'Sesuai'"
                                v-model="vf.p3a1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3a1_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3a1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3a1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada” apabila kedua ketentuan di
                                    atas terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila salah satu
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="4">2</td>
                            <td rowspan="4">
                              Apakah ada program kerja PPB di daerah?
                            </td>
                            <td colspan="3">
                              Penilaian program kerja PPB di daerah dilakukan
                              dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p3a2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Pemda memiliki dan dapat menunjukkan bukti
                                  program kerja
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3a2_file1)"
                                v-if="vf.p3a2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3a2_file1_status == 'Sesuai'"
                                v-model="vf.p3a2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3a2_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3a2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3a2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p3a2_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Pemda memiliki dan dapat menunjukkan bukti
                                  realisasi kegiatan program kerja
                                  (sekurang-kurangnya 50% dari program kerja
                                  yang direncanakan)
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3a2_file2)"
                                v-if="vf.p3a2_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3a2_file2_status == 'Sesuai'"
                                v-model="vf.p3a2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3a2_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3a2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3a2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada” apabila kedua ketentuan di
                                    atas terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila salah satu
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">3</td>
                            <td rowspan="7">
                              Apakah ada rapat koordinasi unit pelaksana PPB?
                            </td>
                            <td colspan="3">
                              Penilaian ada tidaknya rapat koordinasi teragenda
                              dilakukan dengan ketentuan
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p3a3_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 1 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3a3_file1)"
                                v-if="vf.p3a3_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3a3_file1_status == 'Sesuai'"
                                v-model="vf.p3a3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3a3_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3a3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3a3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p3a3_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3a3_file2)"
                                v-if="vf.p3a3_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3a3_file2_status == 'Sesuai'"
                                v-model="vf.p3a3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3a3_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3a3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3a3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p3a3_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3a3_file3)"
                                v-if="vf.p3a3_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3a3_file3_status == 'Sesuai'"
                                v-model="vf.p3a3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3a3_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3a3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3a3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p3a3_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3a3_file4)"
                                v-if="vf.p3a3_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3a3_file4_status == 'Sesuai'"
                                v-model="vf.p3a3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3a3_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3a3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3a3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p3a3_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3a3_file5)"
                                v-if="vf.p3a3_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3a3_file5_status == 'Sesuai'"
                                v-model="vf.p3a3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3a3_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3a3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3a3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="5" style="background-color: #ebedf3">
                              <b
                                >Koordinasi Formal Lintas Pemangku
                                kepentingan</b
                              >
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">1</td>
                            <td rowspan="7">
                              Apakah ada koordinasi formal dengan Pusat?
                            </td>
                            <td colspan="3">
                              Penilaian ada tidaknya koordinasi formal dengan
                              Pusat dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 6 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b1_file1)"
                                v-if="vf.p3b1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b1_file1_status == 'Sesuai'"
                                v-model="vf.p3b1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b1_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b1_file2)"
                                v-if="vf.p3b1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b1_file2_status == 'Sesuai'"
                                v-model="vf.p3b1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b1_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b1_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b1_file3)"
                                v-if="vf.p3b1_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b1_file3_status == 'Sesuai'"
                                v-model="vf.p3b1_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b1_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b1_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b1_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b1_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b1_file4)"
                                v-if="vf.p3b1_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b1_file4_status == 'Sesuai'"
                                v-model="vf.p3b1_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b1_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b1_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b1_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b1_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b1_file5)"
                                v-if="vf.p3b1_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b1_file5_status == 'Sesuai'"
                                v-model="vf.p3b1_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b1_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b1_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b1_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">2</td>
                            <td rowspan="7">
                              Apakah ada koordinasi formal dengan Pemerintah
                              Provinsi?
                            </td>
                            <td colspan="3">
                              Penilaian ada tidaknya koordinasi formal dengan
                              Provinsi dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b2_file1)"
                                v-if="vf.p3b2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b2_file1_status == 'Sesuai'"
                                v-model="vf.p3b2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b2_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b2_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b2_file2)"
                                v-if="vf.p3b2_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b2_file2_status == 'Sesuai'"
                                v-model="vf.p3b2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b2_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b2_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b2_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b2_file3)"
                                v-if="vf.p3b2_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b2_file3_status == 'Sesuai'"
                                v-model="vf.p3b2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b2_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b2_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b2_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b2_file4)"
                                v-if="vf.p3b2_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b2_file4_status == 'Sesuai'"
                                v-model="vf.p3b2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b2_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b2_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b2_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b2_file5)"
                                v-if="vf.p3b2_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b2_file5_status == 'Sesuai'"
                                v-model="vf.p3b2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b2_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b2_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, lebih dari 1 kali” apabila
                                    kelima ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada 1 kali” apabila salah satu
                                    dari ketentuan di atas tidak terpenuhi.
                                    <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">3</td>
                            <td rowspan="7">
                              Apakah ada koordinasi formal dengan daerah
                              lainnya?
                            </td>
                            <td colspan="3">
                              Penilaian ada tidaknya koordinasi formal dengan
                              daerah lainnya dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b3_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b3_file1)"
                                v-if="vf.p3b3_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b3_file1_status == 'Sesuai'"
                                v-model="vf.p3b3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b3_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b3_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b3_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b3_file2)"
                                v-if="vf.p3b3_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b3_file2_status == 'Sesuai'"
                                v-model="vf.p3b3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b3_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b3_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b3_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b3_file3)"
                                v-if="vf.p3b3_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b3_file3_status == 'Sesuai'"
                                v-model="vf.p3b3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b3_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b3_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b3_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b3_file4)"
                                v-if="vf.p3b3_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b3_file4_status == 'Sesuai'"
                                v-model="vf.p3b3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b3_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b3_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b3_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b3_file5)"
                                v-if="vf.p3b3_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b3_file5_status == 'Sesuai'"
                                v-model="vf.p3b3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b3_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b3_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">4</td>
                            <td rowspan="7">
                              Apakah ada koordinasi formal lintas OPD?
                            </td>
                            <td colspan="3">
                              Penilaian ada tidaknya koordinasi formal lintas
                              OPD dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b4_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b4_file1)"
                                v-if="vf.p3b4_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b4_file1_status == 'Sesuai'"
                                v-model="vf.p3b4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b4_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b4_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b4_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b4_file2)"
                                v-if="vf.p3b4_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b4_file2_status == 'Sesuai'"
                                v-model="vf.p3b4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b4_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b4_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b4_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b4_file3)"
                                v-if="vf.p3b4_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b4_file3_status == 'Sesuai'"
                                v-model="vf.p3b4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b4_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b4_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b4_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b4_file4)"
                                v-if="vf.p3b4_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b4_file4_status == 'Sesuai'"
                                v-model="vf.p3b4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b4_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b4_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b4_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b4_file5)"
                                v-if="vf.p3b4_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b4_file5_status == 'Sesuai'"
                                v-model="vf.p3b4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b4_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b4_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="7">5</td>
                            <td rowspan="7">
                              Apakah ada koordinasi pemangku kepentingan lainnya
                              (Perbankan dan APH)?
                            </td>
                            <td colspan="3">
                              Penilaian ada tidaknya koordinasi pemangku
                              kepentingan lainnya (Perbankan dan APH) dilakukan
                              dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b5_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Rapat koordinasi dilakukan sekurang-kurangnya
                                  1 kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b5_file1)"
                                v-if="vf.p3b5_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b5_file1_status == 'Sesuai'"
                                v-model="vf.p3b5_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b5_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b5_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b5_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b5_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b5_file2)"
                                v-if="vf.p3b5_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b5_file2_status == 'Sesuai'"
                                v-model="vf.p3b5_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b5_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b5_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b5_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b5_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat daftar hadir</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b5_file3)"
                                v-if="vf.p3b5_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b5_file3_status == 'Sesuai'"
                                v-model="vf.p3b5_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b5_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b5_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b5_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b5_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Terdapat notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b5_file4)"
                                v-if="vf.p3b5_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b5_file4_status == 'Sesuai'"
                                v-model="vf.p3b5_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b5_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b5_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b5_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3b5_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3b5_file5)"
                                v-if="vf.p3b5_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3b5_file5_status == 'Sesuai'"
                                v-model="vf.p3b5_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3b5_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3b5_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3b5_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="5" style="background-color: #ebedf3">
                              <b>Monitoring dan Evaluasi</b>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="7">1</td>
                            <td rowspan="7">
                              Apakah ada kegiatan monitoring dan evaluasi
                              implementasi PPB?
                            </td>
                            <td colspan="3">
                              Penilaian ada tidaknya kegiatan monitoring dan
                              evaluasi implementasi PPB dilakukan dengan
                              ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3c1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Kegiatan monitoring dan evaluasi dilakukan
                                  sekurang-kurangnya 1 kali dalam 3 bulan
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3c1_file1)"
                                v-if="vf.p3c1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3c1_file1_status == 'Sesuai'"
                                v-model="vf.p3c1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3c1_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3c1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3c1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3c1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat surat undangan resmi dalam bentuk
                                  fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3c1_file2)"
                                v-if="vf.p3c1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3c1_file2_status == 'Sesuai'"
                                v-model="vf.p3c1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3c1_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3c1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3c1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3c1_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3c1_file3)"
                                v-if="vf.p3c1_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3c1_file3_status == 'Sesuai'"
                                v-model="vf.p3c1_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3c1_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3c1_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3c1_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3c1_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat notula sosialisasi
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3c1_file4)"
                                v-if="vf.p3c1_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3c1_file4_status == 'Sesuai'"
                                v-model="vf.p3c1_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3c1_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3c1_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3c1_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3c1_file5 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Terdapat dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3c1_file5)"
                                v-if="vf.p3c1_file5 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3c1_file5_status == 'Sesuai'"
                                v-model="vf.p3c1_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3c1_file5_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3c1_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3c1_file5_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada, teragenda” apabila kelima
                                    ketentuan di atas terpenuhi.<br />
                                    2. Nilai “Ada, tidak teragenda” apabila
                                    salah satu dari ketentuan di atas tidak
                                    terpenuhi. <br />
                                    3. Nilai “Tidak ada” apabila seluruh
                                    ketentuan di atas tidak terpenuhi
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td rowspan="2">2</td>
                            <td rowspan="2">
                              Apakah ada tindak lanjut dan laporan hasil
                              monitoring dan evaluasi kegiatan PPB?
                            </td>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p3c2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  Penilaian keberadaan tindak lanjut dan laporan
                                  hasil monitoring dan evaluasi kegiatan PPB
                                  dilakukan dengan ketentuan apabila laporan
                                  hasil monitoring dan evaluasi kegiatan PPB
                                  dibuat secara formal dalam bentuk dokumen
                                  laporan lengkap fisik atau digital, bukan
                                  bahan presentasi dan sejenisnya
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3c2_file1)"
                                v-if="vf.p3c2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3c2_file1_status == 'Sesuai'"
                                v-model="vf.p3c2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3c2_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3c2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3c2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada” apabila ketentuan di atas
                                    terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila ketentuan di
                                    atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="5" style="background-color: #ebedf3">
                              <b>Tindak lanjut atas hasil Evaluasi</b>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="6">1</td>
                            <td rowspan="6">
                              Apakah ada evaluasi hasil kinerja PPB tahun
                              sebelumnya?
                            </td>
                            <td colspan="3">
                              Penilaian ada tidaknya evaluasi hasil kinerja PPB
                              tahun sebelumnya dilakukan dengan ketentuan:
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3d1_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Tersedia surat undangan resmi evaluasi hasil
                                  kinerja PPB tahun sebelumnya (melibatkan pihak
                                  eksternal) dalam bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3d1_file1)"
                                v-if="vf.p3d1_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3d1_file1_status == 'Sesuai'"
                                v-model="vf.p3d1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3d1_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3d1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3d1_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3d1_file2 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Tersedia daftar hadir peserta rapat dalam
                                  bentuk fisik atau digital
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3d1_file2)"
                                v-if="vf.p3d1_file2 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3d1_file2_status == 'Sesuai'"
                                v-model="vf.p3d1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3d1_file2_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3d1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3d1_file2_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3d1_file3 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">Tersedia notula rapat</div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3d1_file3)"
                                v-if="vf.p3d1_file3 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3d1_file3_status == 'Sesuai'"
                                v-model="vf.p3d1_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3d1_file3_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3d1_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3d1_file3_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col-1">
                                  <i
                                    v-if="vf.p3d1_file4 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </div>
                                <div class="col-11">
                                  Tersedia dokumentasi rapat dalam bentuk foto
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3d1_file4)"
                                v-if="vf.p3d1_file4 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3d1_file4_status == 'Sesuai'"
                                v-model="vf.p3d1_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3d1_file4_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3d1_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3d1_file4_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada” apabila keempat ketentuan di
                                    atas terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila salah satu dari
                                    ketentuan di atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td rowspan="2">2</td>
                            <td rowspan="2">
                              Apakah ada penambahan alokasi anggaran (rutin)
                              pelayanan perizinan berusaha?
                            </td>
                            <td>
                              <div class="row">
                                <di class="col-1">
                                  <i
                                    v-if="vf.p3d2_file1 == null"
                                    style="color: red"
                                    class="flaticon2-cross"
                                  ></i>
                                  <i
                                    v-else
                                    style="color: green"
                                    class="flaticon2-check-mark"
                                  ></i>
                                </di>
                                <div class="col-11" style="text-align: justify">
                                  Penilaian ada tidaknya penambahan alokasi
                                  anggaran (rutin) pelayanan perizinan berusaha
                                  dilakukan dengan ketentuan apabila ada
                                  penambahan alokasi anggaran (rutin) pelayanan
                                  perizinan berusaha
                                </div>
                              </div>
                            </td>
                            <td>
                              <button
                                @click="unduhFile(vf.p3d2_file1)"
                                v-if="vf.p3d2_file1 != null"
                                type="button"
                                size="sm"
                                class="btn btn-success text-uppercase btn-sm"
                              >
                                <i
                                  style="color: white"
                                  class="ml-2 far fa-file-pdf"
                                ></i>
                                Unduh File
                              </button>
                            </td>
                            <td>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: green;
                                  color: white;
                                "
                                v-if="vf.p3d2_file1_status == 'Sesuai'"
                                v-model="vf.p3d2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="
                                  width: 160px;
                                  background-color: red;
                                  color: white;
                                "
                                v-else-if="
                                  vf.p3d2_file1_status == 'Tidak sesuai'
                                "
                                v-model="vf.p3d2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                              <b-form-select
                                disabled
                                style="width: 160px"
                                v-else
                                v-model="vf.p3d2_file1_status"
                                :options="optionsPilihan"
                              ></b-form-select>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">
                              <div
                                style="background-color: #3699ff"
                                class="card card-custom"
                              >
                                <div class="card-body text-green">
                                  <p style="color: white">Informasi</p>
                                  <p style="color: white">
                                    Untuk penetapan bobot penilaian: <br />
                                    1. Nilai “Ada” apabila ketentuan di atas
                                    terpenuhi.<br />
                                    2. Nilai “Tidak ada” apabila ketentuan di
                                    atas tidak terpenuhi.
                                  </p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div v-if="pm.catatan_3_surveyor != null">
                        <div class="card text-white bg-primary mb-3">
                          <!-- <div class="card-header">Header</div> -->
                          <div class="card-body">
                            <h5 class="card-title">
                              <i
                                class="fa fa-info-circle"
                                style="color: white"
                                aria-hidden="true"
                              ></i>
                              Catatan
                            </h5>
                            <hr />
                            <div
                              class="card-text"
                              v-html="pm.catatan_3_surveyor"
                            ></div>
                            <!-- <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> -->
                          </div>
                        </div>
                      </div>
                      <br />
                      <div v-if="pm.catatan_3_bkpm != null">
                        <div
                          class="card text-white bg-danger mb-3"
                          v-if="
                            (user.id_role === 'dpb' || user.id_role === 'kspb') ||
                            user.id_role === 'super_user'
                          "
                        >
                          <!-- <div class="card-header">Header</div> -->
                          <div class="card-body">
                            <h5 class="card-title">
                              <i
                                class="fa fa-info-circle"
                                style="color: white"
                                aria-hidden="true"
                              ></i>
                              Catatan dari BKPM
                            </h5>
                            <hr />
                            <div
                              class="card-text"
                              v-html="pm.catatan_3_bkpm"
                            ></div>
                            <!-- <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p> -->
                          </div>
                        </div>
                      </div>
                      <br />
                      <div
                        v-if="
                          (user.id_role === 'dpb' || user.id_role === 'kspb') ||
                          user.id_role === 'super_user'
                        "
                        class="form-group row"
                      >
                        <label class="col-lg-12 col-form-label"
                          ><b>Catatan untuk surveyor</b></label
                        >
                      </div>
                      <div
                        v-if="
                          (user.id_role === 'dpb' || user.id_role === 'kspb') ||
                          user.id_role === 'super_user'
                        "
                        class="form-group row"
                      >
                        <div class="col-lg-12">
                          <vue-editor v-model="pm.catatan_3_bkpm" />
                        </div>
                      </div>
                      <br />
                      <div class="row">
                        <div class="col-6"></div>
                        <div class="col-6">
                          <button
                            type="button"
                            v-if="
                              (user.id_role === 'dpb' || user.id_role === 'kspb') ||
                              user.id_role === 'super_user'
                            "
                            style="float: right"
                            @click="dokumenpenerapanperizinan"
                            class="btn btn-success font-weight-bolder text-uppercase px-9 py-4"
                          >
                            <i class="fas fa-save"></i>Kirim
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--end: Wizard Step 3-->

                  <!--begin: Wizard Actions -->
                  <div class="d-flex justify-content-between border-top pt-10">
                    <div class="mr-2">
                      <button
                        class="btn btn-light-primary font-weight-bold text-uppercase px-9 py-4"
                        data-wizard-type="action-prev"
                      >
                        Sebelumnya
                      </button>
                    </div>
                    <div>
                      <button
                        v-on:click="submit"
                        class="btn btn-success font-weight-bold text-uppercase px-9 py-4"
                        data-wizard-type="action-submit"
                      >
                        Selesai
                      </button>
                      <button
                        class="btn btn-primary font-weight-bold text-uppercase px-9 py-4"
                        data-wizard-type="action-next"
                      >
                        Selanjutnya
                      </button>
                    </div>
                  </div>
                  <!--end: Wizard Actions -->
                </form>
                <!--end: Wizard Form-->
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Bpdy-->
      </div>
      <!--end: Wizard-->
    </div>
  </div>
</template>
  
  <style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-7.scss";
</style>
  
  
  <script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTUtil from "@/assets/js/components/util";
import KTWizard from "@/assets/js/components/wizard";
import Swal from "sweetalert2";
import axios from "axios";
import VueLoading from "vuejs-loading-plugin";
import Vue from "vue";
import { VueEditor } from "vue2-editor";

Vue.use(VueLoading);

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: "Loading", // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: "rgb(255,255,255)", // set custom background
  classes: ["myclass"], // array, object or string
});

export default {
  name: "Wizard-4",
  components: { VueEditor },
  mounted() {

    this.loadData();

    

    // Initialize form wizard
    const wizard = new KTWizard("kt_wizard_v4", {
      startStep: 1, // initial active step number
      clickableSteps: true, // allow step clicking
    });

    // Validation before going to next page
    wizard.on("beforeNext", function (/*wizardObj*/) {
      // validate the form and use below function to stop the wizard's step
      // wizardObj.stop();
    });

    // Change event
    wizard.on("change", function (/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });

    

    $(document).ready(function () {
      $("#tidaksetuju").click(function () {
        if ($(this).is(":checked")) {
          $("#alasan").show();
          $("#next").hide();
        } else {
          $("#alasan").hide();
          $("#next").show();
        }
      });
      $("#setuju").click(function () {
        if ($(this).is(":checked")) {
          $("#alasan").hide();
          $("#next").show();
        } else {
          $("#alasan").show();
          $("#next").hide();
        }
      });
    });
  },
  data() {
    return {
      url: localStorage.getItem("baseapi"),
      token: localStorage.getItem("id_token"),
      idppbb: null,
      user: JSON.parse(localStorage.getItem("user")),
      pm: [],
      profil: [],
      vf: [],
      selectedFile: null,
      optionsPilihan: [
        { value: "Belum diverifikasi", text: "Belum diverifikasi" },
        { value: "Sesuai", text: "Sesuai" },
        { value: "Tidak sesuai", text: "Tidak sesuai" },
      ],
      tahun: "2026",
    };
  },
  methods: {
    submit: function (e) {
      e.preventDefault();
      Swal.fire({
        title: "",
        text: "Pengisian telah selesai",
        icon: "success",
        confirmButtonClass: "btn btn-secondary",
      });
      this.$router.push({ name: "dashboard" });
    },

    unduhFile(data) {
      window.open(data, "_blank");
    },

    dokumenpenerapanperizinan() {
      axios
        .post(
          this.url + `/pm_ppb_${this.$route.query.type}_2026/` + this.idppbb,
          {
            catatan_1_bkpm: this.pm.catatan_1_bkpm,
            catatan_2_bkpm: this.pm.catatan_2_bkpm,
            catatan_3_bkpm: this.pm.catatan_3_bkpm,
          },
          {
            headers: {
              xth: this.token,
            },
          }
        )
        .then((response) => {
          this.$bvToast.toast("Berhasil ditambahkan", {
            title: `Success `,
            variant: `success`,
            solid: true,
          });
          this.loadData();
          return response;
        })
        .catch((error) => {
          this.$bvToast.toast("Gagal ditambahkan", {
            title: `Failed `,
            variant: `danger`,
            solid: true,
          });
          console.log(error);
          return error;
        });
    },

    loadData() {
      axios
        .get(
          this.url +
            `/pm_ppb_${this.$route.query.type}_2026s?filter=idptsp,=,` +
            this.$route.params.id +
            ";tahun,=," +
            this.tahun,
          {
            headers: {
              xth: this.token,
            },
          }
        )
        .then((response) => {
          this.pm = response.data.data;
          if (this.pm.length == 0) {
            Swal.fire({
              title: "",
              text: "Provinsi / kabupaten / kota ini belum melakukan penilaian",
              icon: "info",
              confirmButtonClass: "btn btn-secondary",
            });
            this.$router.push({ name: "ptsp-provinsi" });
          } else {
            localStorage.setItem(
              "idppb",
              JSON.stringify(response.data.data.id)
            );
            this.idppbb = response.data.data.id;
          }
        });

      axios
        .get(
          this.url +
            `/verifikasi_ppb_${this.$route.query.type}_2026s?filter=idptsp,=,` +
            this.$route.params.id +
            ";tahun,=," +
            this.tahun,
          {
            headers: {
              xth: this.token,
            },
          }
        )
        .then((response) => {
          this.vf = response.data.data;
        });

      axios
        .get(this.url + `/profils?filter=idptsp,=,` + this.$route.params.id, {
          headers: {
            xth: this.token,
          },
        })
        .then((response) => {
          this.profil = response.data.data;

          this.$store.dispatch(SET_BREADCRUMB, [
            {
              title: "PPB Pemda"
            },
            { title: this.profil.daerah }
          ]);
        });
    },
  },
};
</script>
  
  <style scoped>
@media only screen and (max-width: 760px),
  (min-device-width: 768px) and (max-device-width: 768px) {
  /* Force table to not be like tables anymore */
  table,
  thead,
  th,
  td,
  tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr {
    margin: 10px 1rem 1rem 1rem;
  }

  /* tr:nth-child(odd) {
      background: #E1EDFF;
    } */

  td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    /* padding-left: 50%; */
  }

  th {
    display: none;
  }

  /* td:before { */
  /* Now like a table header */
  /* position: absolute; */
  /* Top/left values mimic padding */
  /* top: 0;
			left: 6px;
			width: 45%;
			padding-right: 10px;
			white-space: nowrap; */
  /* } */

  /*
		Label the data
    You could also use a data-* attribute and content for this. That way "bloats" the HTML, this way means you need to keep HTML and CSS in sync. Lea Verou has a clever way to handle with text-shadow.
		*/
  /* td:nth-of-type(1):before { content: "No"; }
		td:nth-of-type(2):before { content: "Indikator"; }
		td:nth-of-type(3):before { content: "Status"; }
		td:nth-of-type(4):before { content: "Jawaban"; }
        td:nth-of-type(5):before { content: "Unggah"; } 
        td:nth-of-type(6):before { content: "Download"; }  */
}
</style>